import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PlacesAutoComplete from "../../components/AddressAutoComplete";
import DateInput from "../../components/DateInput";
import * as Reference from "../../store/ducks/reference.duck";
import * as Registration from "../../store/ducks/registration.duck";
import * as Admin from "../../store/ducks/admin.duck";
import { Button, Form, Row, Col, InputGroup, Table, Modal, Popover, OverlayTrigger, Badge } from "react-bootstrap";
import {
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Checkbox,
  Card,
  FormLabel,
  CardActions,
  CardMedia,
  CardContent,
  Chip,
  TextField,
  makeStyles,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { IconButton, Collapse } from "@material-ui/core";
import { Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import Alert from "@material-ui/lab/Alert";
import { useMediaQuery } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../_metronic";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import GroupIcon from "@material-ui/icons/Group";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Masonry from "react-masonry-css";
import clsx from "clsx";
import { format, differenceInYears } from "date-fns";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import Interweave from "interweave";

import "../../../_metronic/_assets/sass/pages/login/login-1.scss";
import "../../../_metronic/_assets/css/app2.css";

export function EAPRegistrationPage() {
  const { eapToken } = useParams();
  return <ClientRegistrationPage type="EAP" eapToken={eapToken ?? null} />;
}

export function NDISRegistrationPage() {
  return <ClientRegistrationPage type="NDIS" />;
}

export default function ClientRegistrationPage(props) {
  const { invitetoken } = useParams();
  const { eapToken } = useParams();
  const clientInviteStatus = useSelector((state) => state.registration.ClientInviteStatus);

  const [providerType, setProviderType] = useState();
  if (!providerType) {
    if (props.type === "EAP") {
      setProviderType("EAP");
    } else {
      switch (invitetoken) {
        case "new":
          setProviderType("ALL");
          break;
        case "lgbtiq":
          setProviderType("Psychologist");
          break;
        case "perinatal":
          setProviderType("Psychologist");
          break;
        case "newfinancial":
          setProviderType("Financial");
          break;
        case "newgp":
          setProviderType("GP");
          break;
        case "newprovisional":
          setProviderType("Provisional");
          break;
        case "newsocial":
          setProviderType("Social");
          break;
        case "newnurse":
          setProviderType("Nurse");
          break;
        case "newoccupational":
          setProviderType("Occupational");
          break;
        case "newsupervision":
          setProviderType("Supervision");
          break;
        case "nthqldphn":
          setProviderType("NthQLDPHN");
          break;
        default:
          setProviderType("Psychologist");
          break;
      }
    }
  }

  const dispatch = useDispatch();
  // useEffect( () => { dispatch(Registration.actions.fetchClientInvite(invitetoken))  }, [dispatch, invitetoken] )
  useEffect(() => {
    dispatch(
      Reference.actions.fetchAreasOfInterest({
        providerType: "ALL",
        centralisedservice: false,
      }),
    );
  }, [dispatch]);
  useEffect(() => {
    dispatch(
      Registration.actions.fetchRegisteredPublic({
        inviteToken: invitetoken,
        providerType: providerType,
      }),
    );
  }, [dispatch, invitetoken, providerType]);
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchSupervisionAreas());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchPrograms());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchWWCC());
  }, [dispatch]);

  useEffect(() => {
    // console.log("Use Effect - 1  Invite AOI Triggered");
    if (!invitetoken) return;

    const localTokens = [
      "new",
      "newgp",
      "newsocial",
      "newnurse",
      "newoccupational",
      "newprovisional",
      "newsupervision",
      "newfinancial",
      "perinatal",
      "lgbtiq",
      "nthqldphn",
    ];

    if (localTokens.includes(invitetoken)) {
      // Local token → no saga
      return;
    }

    // GUID token → fetch via saga
    if (clientInviteStatus === "idle") {
      dispatch(Registration.actions.fetchClientInvite(invitetoken));
    }
  }, [invitetoken, clientInviteStatus, dispatch]);

  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  const registered = useSelector((state) => state.registration.Registered);
  const invite = useSelector((state) => state.registration.ClientInvite);
  const programs = useSelector((state) => state.admin.Programs);

  // const regstatus = useSelector(state =>  state.registration.regstatus)
  const [aoiTouched, setaoiTouched] = useState(false);
  // Determine browser timezone
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const browserTZMS =
    timeZone && timeZone.some((tz) => tz.ianaName === browserTZ) ? timeZone.find((tz) => tz.ianaName === browserTZ) : timeZone.find((tz) => tz.tzIndex === "6");
  // const browserTZMS = timeZone && timeZone.find(tz => tz.ianaName === browserTZ)

  useEffect(() => {
    // console.log("Use Effect - 2  Invite AOI Triggered");

    // console.log("Props", props);
    // console.log("Dependencies", {
    //   invitetoken,
    //   clientInviteStatus,
    //   aoiTouched,
    //   browserTZMS,
    //   areasOfInterestReference,
    //   programs,
    // });

    if (aoiTouched) return;
    if (!invitetoken && !props.type) return;
    if (!browserTZMS) return;
    if (!areasOfInterestReference?.length) return;
    // if (!registered.length) return;
    if (!programs.length) return;

    const localTokens = [
      "new",
      "newgp",
      "newsocial",
      "newnurse",
      "newoccupational",
      "newprovisional",
      "newsupervision",
      "newfinancial",
      "perinatal",
      "lgbtiq",
      "nthqldphn",
    ];
    // console.log("Use Effect - 2  Part 2");
    const isLocalToken = localTokens.includes(invitetoken);

    // CASE 1: GUID invite → wait for saga
    if (!isLocalToken && clientInviteStatus === "loaded") {
      // console.log('Use Effect - 2  Case 1')
      loadInviteAOI();
    }

    // CASE 2: Local token → no saga needed
    if (isLocalToken) {
      //console.log('Use Effect - 2  Case 2')
      loadInviteAOI();
    }

    // CASE 3: Type Set via props (EAP) → no saga needed
    if (props.type === "EAP") {
      // console.log('Use Effect - 2  Case 3')
      loadInviteAOI();
    }

    if (props.type === "NDIS") {
      // console.log('Use Effect - 2  Case 4')
      loadInviteAOI();
    }
  }, [
    invitetoken,
    clientInviteStatus,
    aoiTouched,
    browserTZMS,
    areasOfInterestReference,
    // registered,
    programs,
    props.type,
  ]);

  const [steps, setSteps] = useState({
    step1: {
      title: "1. Areas of Interest",
      status: "Not Started",
      data: [],
      search: [],
    },
    step2: {
      title: "2. Select Psychologist",
      status: "Not Started",
      data: {},
      bookingdate: undefined,
      providerType: providerType,
      userTZ: browserTZMS && browserTZMS.systemName,
      userutcOffset: "",
      paymenttype: "",
      healthCareCard: "",
      unemployed: "",
      naturalDisaster: "",
      bulkBilledReason: "",
      reducedGapReason: "",
    },
    step3: {
      title: "3. Registration Form",
      status: "Not Started",
      data: {},
      providerType: providerType,
    },
    step4: {
      title: "4. Confirmation",
      status: "Not Started",
      data: {},
      providerType: providerType,
    },
    step5: {
      title: "4. Form Submitted",
      status: "Not Started",
      data: {},
      providerType: providerType,
    },
    step6: {
      title: "6. Providers Unavailable",
      status: "Not Started",
      data: {},
      providerType: providerType,
    },
    currentStep: 1,
    message: "",
  });

  const setStepValue = (value) => {
    setSteps({ ...steps, ...value });
  };

  // Check if there was an invite guid
  const loadInviteAOI = () => {
    // console.log("Load Invite AOI Called");
    if (aoiTouched) return;

    // GUID token but saga not finished → bail
    if (invitetoken && invitetoken.length > 20 && clientInviteStatus !== "loaded") {
      return;
    }

    // console.log("Invite", invite && invitetoken ? invitetoken : "No Invite");

    if (
      invite &&
      invitetoken !== "new" &&
      invitetoken !== "newoccupational" &&
      invitetoken !== "newsocial" &&
      invitetoken !== "newnurse" &&
      invitetoken !== "newsupervision" &&
      invitetoken !== "newprovisional" &&
      invitetoken !== "newfinancial" &&
      invitetoken !== "newgp" &&
      invitetoken !== "perinatal" &&
      invitetoken !== "lgbtiq" &&
      invitetoken !== "nthqldphn" &&
      Object.keys(invite).length > 0 &&
      !programs.find((program) => program.identifier === invitetoken)
    ) {
      // Determine invite providertype before reviewing aoi
      // console.log('Inside If')
      setProviderType(invite.providertype);
      // add aoi from invite
      var aoi = areasOfInterestReference.filter(({ issue }) => invite.clientAreasOfInterest.includes(issue));
      var newSteps = {
        ...steps,
        ...{
          step1: { status: "Completed", data: aoi, search: aoi },
          currentStep: 2,
          message: invite.message,
        },
      };
      // add psychologist from invite

      var selectedPsychologist = registered.find((row) => row.id === invite.psychologistid);
      if (invite.psychologistid) {
        newSteps = {
          ...newSteps,
          ...{
            step2: {
              ...newSteps.step2,
              ...{
                status: "Completed",
                data: { ...selectedPsychologist },
                paymenttype: invite.paymenttype,
                bulkBilledReason: invite.bulkbilledreason,
                bookingdate: invite.bookingdate,
                providerType: invite.providertype,
                userTZ: invite.timezone,
              },
            },
            currentStep: selectedPsychologist && invite.bookingdate ? 3 : 2,
          },
        };
      } else {
        // Need to default payment type for GP to Bulk Billed
        if (invite.providertype === "GP") {
          // console.log(invite)
          // console.log(programs)
          // console.log(programs.find(program => program.id === invite.programid))
          if (invite.programid && programs.find((program) => program.id === invite.programid)) {
            // Ok the invite token was a program identifer
            // console.log(invite)
            var program = programs.find((program) => program.id === invite.programid);
            // find AOI issue label
            var aoiProgram = areasOfInterestReference.filter((aoi) => aoi.id === program.aoi.toString());
            // console.log('Program',program.id)
            // console.log(aoiProgram)
            newSteps = {
              ...steps,
              ...{
                step1: {
                  ...steps.step1,
                  ...{
                    status: "Completed",
                    data: aoiProgram,
                    search: aoiProgram,
                  },
                },
                step2: {
                  ...steps.step2,
                  ...{
                    status: "In Progress",
                    programid: program.id,
                    program: program.bulkbilling && program.bulkbilling === "Y" ? true : false,
                    fixAOI: true,
                    data: {},
                    paymenttype: "Bulk Billed",
                    bookingdate: null,
                    providerType: invite.providertype,
                    userTZ: invite.timezone,
                  },
                },
                currentStep: 2,
              },
            };
            // console.log('New Steps')
            // console.log(newSteps)
          } else {
            newSteps = {
              ...newSteps,
              ...{
                step2: {
                  ...newSteps.step2,
                  ...{
                    status: "In Progress",
                    data: {},
                    bookingdate: null,
                    paymenttype: "Bulk Billed",
                    providerType: invite.providertype,
                    userTZ: invite.timezone,
                  },
                },
                currentStep: 2,
              },
            };
          }
        } else {
          if (invite.providertype === "Financial") {
            newSteps = {
              ...newSteps,
              ...{
                step2: {
                  ...newSteps.step2,
                  ...{
                    status: "In Progress",
                    data: {},
                    bookingdate: null,
                    paymenttype: "Reduced Gap",
                    providerType: invite.providertype,
                    userTZ: invite.timezone,
                  },
                },
                currentStep: 2,
              },
            };
          } else {
            if (invite.providertype === "Provisional") {
              newSteps = {
                ...newSteps,
                ...{
                  step2: {
                    ...newSteps.step2,
                    ...{
                      status: "In Progress",
                      data: {},
                      bookingdate: null,
                      paymenttype: "Provisional",
                      providerType: invite.providertype,
                      userTZ: invite.timezone,
                    },
                  },
                  currentStep: 2,
                },
              };
            } else {
              if (invite.providertype === "Social") {
                // Check to see if any AOI have been selected
                if (aoi && aoi.length > 0) {
                  // AOI found in invite
                  newSteps = {
                    ...newSteps,
                    ...{
                      step2: {
                        ...newSteps.step2,
                        ...{
                          status: "In Progress",
                          data: {},
                          bookingdate: null,
                          paymenttype: invite.paymenttype,
                          bulkBilledReason: invite.bulkbilledreason,
                          providerType: invite.providertype,
                          userTZ: invite.timezone,
                        },
                      },
                      currentStep: 2,
                    },
                  };
                } else {
                  // No AOI found in invite
                  newSteps = {
                    ...steps,
                    ...{
                      step1: {
                        ...steps.step1,
                        ...{ status: "Not Started", data: [], search: [] },
                      },
                      step2: {
                        ...steps.step2,
                        ...{
                          status: "Not Started",
                          data: {},
                          bookingdate: null,
                          paymenttype: invite.paymenttype,
                          bulkBilledReason: invite.bulkbilledreason,
                          providerType: invite.providertype,
                          userTZ: invite.timezone,
                        },
                      },
                      currentStep: 1,
                    },
                  };
                }
                // newSteps = {...newSteps, ...{ step2: { ...newSteps.step2, ...{ status: 'In Progress', data: {}, bookingdate: null, paymenttype: invite.paymenttype, providerType: invite.providertype, userTZ: invite.timezone }}, currentStep: 1 }}
              } else {
                if (invite.providertype === "Occupational") {
                  // Check to see if any AOI have been selected
                  if (aoi && aoi.length > 0) {
                    // AOI found in invite
                    newSteps = {
                      ...newSteps,
                      ...{
                        step2: {
                          ...newSteps.step2,
                          ...{
                            status: "In Progress",
                            data: {},
                            bookingdate: null,
                            paymenttype: invite.paymenttype,
                            bulkBilledReason: invite.bulkbilledreason,
                            providerType: invite.providertype,
                            userTZ: invite.timezone,
                          },
                        },
                        currentStep: 2,
                      },
                    };
                  } else {
                    // No AOI found in invite
                    newSteps = {
                      ...steps,
                      ...{
                        step1: {
                          ...steps.step1,
                          ...{ status: "Not Started", data: [], search: [] },
                        },
                        step2: {
                          ...steps.step2,
                          ...{
                            status: "Not Started",
                            data: {},
                            bookingdate: null,
                            paymenttype: invite.paymenttype,
                            bulkBilledReason: invite.bulkbilledreason,
                            providerType: invite.providertype,
                            userTZ: invite.timezone,
                          },
                        },
                        currentStep: 1,
                      },
                    };
                  }
                  // newSteps = {...newSteps, ...{ step2: { ...newSteps.step2, ...{ status: 'In Progress', data: {}, bookingdate: null, paymenttype: invite.paymenttype, providerType: invite.providertype, userTZ: invite.timezone }}, currentStep: 1 }}
                } else {
                  if (invite.providertype === "Nurse") {
                    // Check to see if any AOI have been selected
                    if (aoi && aoi.length > 0) {
                      // AOI found in invite
                      newSteps = {
                        ...newSteps,
                        ...{
                          step2: {
                            ...newSteps.step2,
                            ...{
                              status: "In Progress",
                              data: {},
                              bookingdate: null,
                              paymenttype: invite.paymenttype,
                              bulkBilledReason: invite.bulkbilledreason,
                              providerType: invite.providertype,
                              userTZ: invite.timezone,
                            },
                          },
                          currentStep: 2,
                        },
                      };
                    } else {
                      // No AOI found in invite
                      newSteps = {
                        ...steps,
                        ...{
                          step1: {
                            ...steps.step1,
                            ...{ status: "Not Started", data: [], search: [] },
                          },
                          step2: {
                            ...steps.step2,
                            ...{
                              status: "Not Started",
                              data: {},
                              bookingdate: null,
                              paymenttype: invite.paymenttype,
                              bulkBilledReason: invite.bulkbilledreason,
                              providerType: invite.providertype,
                              userTZ: invite.timezone,
                            },
                          },
                          currentStep: 1,
                        },
                      };
                    }
                    // newSteps = {...newSteps, ...{ step2: { ...newSteps.step2, ...{ status: 'In Progress', data: {}, bookingdate: null, paymenttype: invite.paymenttype, providerType: invite.providertype, userTZ: invite.timezone }}, currentStep: 1 }}
                  } else {
                    if (invite.providertype === "NDIS") {
                      newSteps = {
                        ...newSteps,
                        ...{
                          step2: {
                            ...steps.step2,
                            ...{
                              status: "Completed",
                              data: {},
                              paymenttype: "NDIS",
                              bookingdate: null,
                              providerType: "NDIS",
                              userTZ: browserTZMS.systemName,
                            },
                          },
                          currentStep: 3,
                        },
                      };
                    } else {
                      if (invite.providertype === "Supervision") {
                        newSteps = {
                          ...newSteps,
                          ...{
                            step2: {
                              ...newSteps.step2,
                              ...{
                                status: "In Progress",
                                data: {},
                                bookingdate: null,
                                paymenttype: "Supervision",
                                providerType: invite.providertype,
                                userTZ: invite.timezone,
                              },
                            },
                            currentStep: 2,
                          },
                        };
                      } else {
                        //console.log(invite);
                        // console.log(programs);
                        // console.log(programs.find((program) => program.id === invite.programid));
                        if (invite.programid && programs.find((program) => program.id === invite.programid)) {
                          // Ok the invite token was a program identifer
                          // console.log(invite)
                          var program = programs.find((program) => program.id === invite.programid);
                          // find AOI issue label
                          var aoiProgram = areasOfInterestReference.filter((aoi) => aoi.id === program.aoi.toString());
                          // console.log('Program',program.id)
                          // console.log(aoiProgram)
                          newSteps = {
                            ...steps,
                            ...{
                              step1: {
                                ...steps.step1,
                                ...{
                                  status: "Completed",
                                  data: aoiProgram,
                                  search: aoiProgram,
                                },
                              },
                              step2: {
                                ...steps.step2,
                                ...{
                                  status: "In Progress",
                                  programid: program.id,
                                  program: program.bulkbilling && program.bulkbilling === "Y" ? true : false,
                                  paymenttype: "Bulk Billed",
                                  fixAOI: true,
                                  data: {},
                                  bookingdate: null,
                                  providerType: "Psychologist",
                                  userTZ: invite.timezone,
                                },
                              },
                              currentStep: 2,
                            },
                          };
                          // console.log('New Steps')
                          // console.log(newSteps)
                        } else {
                          // Check to see if any AOI have been selected
                          if (aoi && aoi.length > 0) {
                            // console.log('AOI Set')
                            // AOI found in invite
                            newSteps = {
                              ...newSteps,
                              ...{
                                step2: {
                                  ...newSteps.step2,
                                  ...{
                                    status: "In Progress",
                                    data: {},
                                    bookingdate: null,
                                    paymenttype: invite.paymenttype,
                                    bulkBilledReason: invite.bulkbilledreason,
                                    providerType: invite.providertype,
                                    userTZ: invite.timezone,
                                  },
                                },
                                currentStep: 2,
                              },
                            };
                          } else {
                            // console.log('AOI Not Set')
                            // No AOI found in invite
                            // newSteps = {...newSteps, ...{ step1: { ...newSteps.step1, ...{  status: 'Not Started', data: [], search: [],  bookingdate: null, paymenttype: invite.paymenttype, providerType: invite.providertype, userTZ: invite.timezone }}, currentStep: 1 }}
                            newSteps = {
                              ...steps,
                              ...{
                                step1: {
                                  ...steps.step1,
                                  ...{
                                    status: "Not Started",
                                    data: [],
                                    search: [],
                                  },
                                },
                                step2: {
                                  ...steps.step2,
                                  ...{
                                    status: "Not Started",
                                    data: {},
                                    bookingdate: null,
                                    paymenttype: invite.paymenttype,
                                    bulkBilledReason: invite.bulkbilledreason,
                                    providerType: invite.providertype,
                                    userTZ: invite.timezone,
                                  },
                                },
                                currentStep: 1,
                              },
                            };
                            // newSteps = {...newSteps, ...{ step2: { ...newSteps.step2, ...{ status: 'Not Started', data: {}, bookingdate: null, paymenttype: invite.paymenttype, bulkBilledReason : invite.bulkbilledreason, providerType: invite.providertype, userTZ: invite.timezone }} }}
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      setStepValue(newSteps);
      setaoiTouched(true);
    } else {
      // Ok Non Invite
      // Handle non invite GP
      if (invitetoken && invitetoken === "newgp" && !aoiTouched && browserTZMS) {
        setProviderType("GP");
        var gpNewSteps = {
          step1: { status: "Completed", data: [], search: [] },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select GP",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "GP",
              paymenttype: "Bulk Billed",
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        gpNewSteps = { ...gpNewSteps, currentStep: 2 };
        setStepValue(gpNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite Supervision
      if (invitetoken && invitetoken === "newsupervision" && !aoiTouched && browserTZMS) {
        setProviderType("Supervision");
        var supervisionNewSteps = {
          step1: { status: "Completed", data: [], search: [] },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select Supervising Psychologist",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "Supervision",
              paymenttype: "Supervision",
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        supervisionNewSteps = { ...supervisionNewSteps, currentStep: 2 };
        setStepValue(supervisionNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite Provisional
      if (invitetoken && invitetoken === "newprovisional" && !aoiTouched && browserTZMS) {
        setProviderType("Provisional");
        var provisionalNewSteps = {
          step1: { status: "Completed", data: [], search: [] },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select Provisional Psychologist",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "Provisional",
              paymenttype: "Provisional",
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        provisionalNewSteps = { ...provisionalNewSteps, currentStep: 2 };
        setStepValue(provisionalNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite Social
      if (invitetoken && invitetoken === "newsocial" && !aoiTouched && browserTZMS) {
        setProviderType("Social");
        var socialNewSteps = {
          step1: {
            ...steps.step1,
            ...{ status: "Not Started", data: [], search: [] },
          },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select MH Social Worker",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "Social",
              paymenttype: null,
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        socialNewSteps = { ...socialNewSteps, currentStep: 1 };
        setStepValue(socialNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite Nurse
      if (invitetoken && invitetoken === "newnurse" && !aoiTouched && browserTZMS) {
        setProviderType("Nurse");
        var nurseNewSteps = {
          step1: {
            ...steps.step1,
            ...{ status: "Not Started", data: [], search: [] },
          },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select Mental Health Nurse",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "Nurse",
              paymenttype: null,
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        nurseNewSteps = { ...nurseNewSteps, currentStep: 1 };
        setStepValue(nurseNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite Occupational
      if (invitetoken && invitetoken === "newoccupational" && !aoiTouched && browserTZMS) {
        setProviderType("Occupational");
        var occupationalNewSteps = {
          step1: {
            ...steps.step1,
            ...{ status: "Not Started", data: [], search: [] },
          },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select Occupational Therapist",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "Occupational",
              paymenttype: null,
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        occupationalNewSteps = { ...occupationalNewSteps, currentStep: 1 };
        setStepValue(occupationalNewSteps);
        setaoiTouched(true);
      }
      // Handle non invite NthQLDPHN
      if (invitetoken && invitetoken === "nthqldphn" && !aoiTouched && browserTZMS) {
        setProviderType("NthQLDPHN");
        var nthqldphnNewSteps = {
          step1: {
            ...steps.step1,
            ...{ status: "Not Started", data: [], search: [] },
          },
          step2: {
            ...steps.step2,
            ...{
              title: "2. Select Provider",
              status: "Not Started",
              data: {},
              bookingdate: undefined,
              providerType: "NthQLDPHN",
              paymenttype: "Contract",
              userTZ: browserTZMS.systemName,
              userutcOffset: "",
            },
          },
        };
        // Set the step to step 2
        nthqldphnNewSteps = { ...nthqldphnNewSteps, currentStep: 1 };
        setStepValue(nthqldphnNewSteps);
        setaoiTouched(true);
      }
    }
    // Handle LGBTIQ
    if (invitetoken && invitetoken === "lgbtiq" && !aoiTouched && registered.length > 0) {
      // This simply pre populates the AOI for LGBTIQ
      var lgbtiqAoi = areasOfInterestReference.filter((area) => area.issue === "LGBTIQA+");
      var lgbtiqNewSteps = {
        ...steps,
        ...{
          step1: {
            ...steps.step1,
            ...{ status: "In Progress", data: lgbtiqAoi, search: lgbtiqAoi },
          },
          currentStep: 1,
        },
      };
      setStepValue(lgbtiqNewSteps);
      setaoiTouched(true);
    }
    // Handle PeriNatal
    if (invitetoken && invitetoken === "perinatal" && !aoiTouched && registered.length > 0) {
      // This simply pre populates the AOI for PeriNatal
      var periNatalAoi = areasOfInterestReference.filter((area) => area.issue === "Miscarriage or Stillbirth and Loss of baby");
      var periNatalNewSteps = {
        ...steps,
        ...{
          step1: {
            ...steps.step1,
            ...{
              status: "In Progress",
              data: periNatalAoi,
              search: periNatalAoi,
            },
          },
          currentStep: 1,
        },
      };
      setStepValue(periNatalNewSteps);
      setaoiTouched(true);
    }
    // Handle EAP
    if (props.type && props.type === "EAP" && !aoiTouched && browserTZMS) {
      // Ok this will be exciting
      // EAP clients access simply using a URL - they do not choose AOI though now choose a Psychologist (with all AOI) - this is all handled manually by Admin
      // As of 2025-05-29 EAP clients now select AOI and Psychologist
      //
      setProviderType("EAP");
      var eapNewSteps = {
        step1: {
          ...steps.step1,
          ...{ status: "Not Started", data: [], search: [] },
        },
        step2: {
          ...steps.step2,
          ...{
            title: "2. Select Provider",
            status: "Not Started",
            data: {},
            bookingdate: undefined,
            providerType: "EAP",
            paymenttype: "EAP",
            userTZ: browserTZMS.systemName,
            userutcOffset: "",
          },
        },
      };
      // Set the step to step 1
      eapNewSteps = { ...eapNewSteps, currentStep: 1 };
      setStepValue(eapNewSteps);
      setaoiTouched(true);
    }
    // Handle NDIS
    if (props.type && props.type === "NDIS" && !aoiTouched && browserTZMS) {
      // Ok this will be exciting
      // NDIS clients access simply using a URL - they do not choose AOI or a Psychologist - this is all handled manually by Admin
      //
      setProviderType("NDIS");
      var ndisNewSteps = {
        ...steps,
        ...{
          step2: {
            ...steps.step2,
            ...{
              status: "Completed",
              data: {},
              paymenttype: "NDIS",
              bookingdate: null,
              providerType: "NDIS",
              userTZ: browserTZMS.systemName,
            },
          },
          currentStep: 3,
        },
      };
      // Ok all done - lets go
      setStepValue(ndisNewSteps);
      setaoiTouched(true);
    }
    // Handle Program
    if (
      invitetoken &&
      programs.find((program) => program.identifier === invitetoken) &&
      !aoiTouched &&
      browserTZMS &&
      areasOfInterestReference &&
      areasOfInterestReference.length > 0
    ) {
      // Ok the invite token was a program identifer
      var programNI = programs.find((program) => program.identifier === invitetoken);
      // find AOI issue label
      var aoiProgramNI = areasOfInterestReference.filter((aoi) => aoi.id === programNI.aoi.toString());
      // console.log("ProgramNI", programNI.id);
      var programNewSteps = {
        ...steps,
        ...{
          step1: {
            ...steps.step1,
            ...{
              status: "Completed",
              data: aoiProgramNI,
              search: aoiProgramNI,
            },
          },
          step2: {
            ...steps.step2,
            ...{
              status: "In Progress",
              programid: programNI.id,
              program: programNI.bulkbilling && programNI.bulkbilling === "Y" ? true : false,
              paymenttype: programNI.bulkbilling && programNI.bulkbilling === "Y" ? "Bulk Billed" : null,
              fixAOI: true,
              data: {},
              bookingdate: null,
              providerType: "Psychologist",
              userTZ: browserTZMS.systemName,
            },
          },
          currentStep: 2,
        },
      };
      setStepValue(programNewSteps);
      setaoiTouched(true);
    }
  };
  // when the invite is converted to a client, show the confirmation message and link to the login page
  // Old test for registration completed - left people hanging if APi errored  ((regstatus.form === 'client' && regstatus.status === 'Success' && regstatus.newID) || (invite && invite.hasOwnProperty('clientid') && invite.clientid))
  switch (steps.currentStep) {
    case 1:
      return (
        <PageWrapper setStepValue={setStepValue} steps={steps} providerType={providerType}>
          <AreasOfInterest
            setStepValue={setStepValue}
            steps={steps}
            setaoiTouched={setaoiTouched}
            providerType={providerType}
            userTZ={browserTZMS}
            contract={(invite && invite.contract) || providerType === "NthQLDPHN"}
          />
        </PageWrapper>
      );
    case 2:
      return (
        <PageWrapper
          setStepValue={setStepValue}
          steps={steps}
          providerType={providerType}
          userTZ={browserTZMS}
          contract={(invite && invite.contract) || providerType === "NthQLDPHN"}
        >
          <SelectPsychologist setStepValue={setStepValue} steps={steps} userTZ={browserTZMS} />
        </PageWrapper>
      );
    case 3:
      return (
        <PageWrapper
          setStepValue={setStepValue}
          steps={steps}
          providerType={providerType}
          contract={(invite && invite.contract) || providerType === "NthQLDPHN"}
        >
          {(steps.step2.data.id &&
            steps.step2.data.id > 0 &&
            (steps.step1.data.length > 0 || providerType === "GP" || providerType === "Supervision" || providerType === "Provisional") &&
            steps.step2.userTZ &&
            steps.step2.userTZ.length > 0 &&
            steps.step2.bookingdate &&
            steps.step2.bookingdate.length > 0) ||
          providerType === "NDIS" ? (
            <ClientRegistrationForm setStepValue={setStepValue} steps={steps} providerType={providerType} />
          ) : (
            <ClientRegistrationNotReady setStepValue={setStepValue} steps={steps} providerType={providerType} />
          )}
        </PageWrapper>
      );
    case 4:
      return (
        <PageWrapper setStepValue={setStepValue} steps={steps} providerType={providerType}>
          <ClientRegistrationConfirmation steps={steps} providerType={providerType} />
        </PageWrapper>
      );
    case 5:
      return (
        <PageWrapper setStepValue={setStepValue} steps={steps} providerType={providerType}>
          <ClientSupportFormConfirmation steps={steps} providerType={providerType} />
        </PageWrapper>
      );
    case 6:
      return (
        <PageWrapper setStepValue={setStepValue} steps={steps} providerType={providerType}>
          <ClientNoWWCCProviders steps={steps} providerType={providerType} />
        </PageWrapper>
      );

    default:
      return "Default";
  }
}

function AreasOfInterest(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 340,
      backgroundColor: theme.palette.background.paper,
      paddingRight: 20,
      marginTop: 14,
      marginLeft: 20,
    },
    linkItem: {
      minWidth: 50,
    },
    link: {
      color: "rgba(0,0,0,0.7)",
      fontSize: 12,
      fontWeight: 400,
    },
    linkSelected: {
      color: "rgba(0,0,0,1)",
      fontSize: 12,
      fontWeight: 600,
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);

  // Setup variables for Psychology and Financial Areas of Interest (note GP's do not have areas of interest)
  const PsychologyAreasOfInterest = areasOfInterestReference.filter((area) => area.providertype === "Psychologist");
  const FinancialAreasOfInterest = areasOfInterestReference.filter((area) => area.providertype === "Financial");
  const ProvisionalAreasOfInterest = areasOfInterestReference.filter(
    (area) => area.issue === "Anxiety" || area.issue === "Depression" || area.issue === "Grief",
  );
  const aoi_focus = PsychologyAreasOfInterest.filter((aoi) => aoi.focusAreaIndex !== null).length;
  const aoi_other = PsychologyAreasOfInterest.filter((aoi) => aoi.focusAreaIndex === null).length;
  const invite = useSelector((state) => state.registration.ClientInvite);
  const [checked, setChecked] = useState([...props.steps.step1.data]);
  const [currentWWCCState, setCurrentWWCCState] = useState("");
  const programs = useSelector((state) => state.admin.Programs);
  const wwcc = useSelector((state) => state.reference.WWCC);
  const aoi_wwcc = useSelector((state) => state.reference.AreasOfInterest).filter((aoi) => aoi.wwcc === 1);
  const [aoiError, setAoiError] = useState("");

  useEffect(() => {
    setChecked(props.steps.step1.data);
  }, [setChecked, props.steps.step1.data]);

  const handleToggle = (value) => () => {
    const currentIndex = getIndex(value.id, checked, "id");
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);

    if (newChecked.length > 0) {
      setAoiError("");
    }
  };

  const submitAOI = () => {
    if (!checked || checked.length === 0) {
      setAoiError("Please select at least one area of interest before continuing.");
      return;
    }
    setAoiError("");

    props.setaoiTouched(true);
    // Set Title
    let title = "";
    let paymentTypeSelect = "";
    switch (props.providerType) {
      case "Clinical":
      case "Psychologist":
        title = "2. Select Psychologist";
        // paymentTypeSelect = 'Reduced Gap';
        break;
      case "Provisional":
        title = "2. Select Provisional Psychologist";
        paymentTypeSelect = "Provisional";
        break;
      case "Financial":
        title = "2. Select Financial Counsellor";
        paymentTypeSelect = "Reduced Gap";
        break;
      case "GP":
        title = "2. Select GP";
        break;
      case "Social":
        title = "2. Select MH Social Worker";
        // paymentTypeSelect = 'Reduced Gap';
        break;
      case "Nurse":
        title = "2. Select Mental Health Nurse";
        // paymentTypeSelect = 'Reduced Gap';
        break;
      case "Occupational":
        title = "2. Select Occupational Therapist";
        // paymentTypeSelect = 'Reduced Gap';
        break;
      case "Supervision":
        title = "2. Select Supervising Psychologist";
        break;
      case "NthQLDPHN":
        title = "2. Select Provider";
        paymentTypeSelect = "Contract";
        break;
      case "EAP":
        title = "2. Select Provider";
        paymentTypeSelect = "EAP";
        break;
      default:
        title = "2. Select Provider";
        break;
    }

    // Megan has requested any one who ticks 'Perinatal Grief and Loss' is only shown those providers specialising in that AOI (i.e. program)
    // All very hardcoded
    // Thus the code below
    var specialAOI = checked.filter((aoi) => aoi.issue === "Perinatal Grief and Loss");
    if (specialAOI && specialAOI.length > 0) {
      // Ok we found one - lets use that
      // Need to get the program information
      // console.log('Special AOI')
      // console.log(specialAOI[0].id)
      // console.log('Programs')
      // console.log(programs)
      var programClientSelect = programs.find((program) => program.aoi.toString() === specialAOI[0].id);
      props.setStepValue({
        step1: {
          status: "Completed",
          data: [...specialAOI],
          search: [...specialAOI],
        },
        step2: {
          ...props.steps.step2,
          ...{
            title: title,
            status: "Not Started",
            programid: programClientSelect.id,
            program: programClientSelect.bulkbilling && programClientSelect.bulkbilling === "Y" ? true : false,
            fixAOI: true,
            data: {},
            bookingdate: undefined,
            providerType: props.providerType,
            paymenttype: "Bulk Billed",
          },
        },
        currentStep: 2,
      });
      // Need to get a new list of providers with the program selected
      dispatch(
        Registration.actions.fetchRegisteredPublic({
          inviteToken: "pgnl",
          providerType: props.providerType,
        }),
      );
    } else {
      props.setStepValue({
        step1: {
          status: "Completed",
          data: [...checked],
          search: [...checked],
        },
        step2: {
          ...props.steps.step2,
          ...{
            title: title,
            status: "Not Started",
            data: {},
            bookingdate: undefined,
            providerType: props.providerType,
            paymenttype: paymentTypeSelect,
            homeState: currentWWCCState,
          },
        },
        currentStep: 2,
      });
    }
  };

  function getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1; // where the value doesn't exist
  }

  return (
    <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
      {props.providerType &&
      (props.providerType === "ALL" ||
        props.providerType === "NthQLDPHN" ||
        props.providerType === "EAP" ||
        props.providerType === "Psychologist" ||
        props.providerType === "Clinical" ||
        props.providerType === "Occupational" ||
        props.providerType === "Supervision" ||
        props.providerType === "Nurse" ||
        props.providerType === "Social") ? (
        <>
          <Row>
            <Col md="12">
              <h2>1. Areas of Interest</h2>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              {props.steps.message ? (
                <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                  {props.steps.message}
                </Alert>
              ) : null}
            </Col>
          </Row>

          {(!invite || (invite && invite.contractid !== 11)) && props.providerType !== "EAP" ? (
            <Row>
              <Col md="12">
                <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                  <p>Please note:</p>
                  <ul>
                    <li>
                      <p>
                        If you want to claim your sessions on Medicare you will need a mental health treatment plan from your GP. You can download a flyer with
                        our referral information to show your GP{" "}
                        <a
                          href={`https://ruralhealthconnect.com.au/assets/RHC-client-flyer-V02.pdf`}
                          target="ClientGPInformation"
                          style={{ textDecoration: "underline" }}
                        >
                          here.
                        </a>
                      </p>
                    </li>
                    <li>
                      <p>
                        Rural Health Connect therapists provide ongoing support and are <strong>unable</strong> to provide reports, assessments for Centrelink
                        or reporting for court.{" "}
                      </p>
                    </li>
                  </ul>
                </Alert>
              </Col>
            </Row>
          ) : null}

          <hr style={{ marginTop: 4 }}></hr>
          <Row>
            <Col md="12">
              <Form.Group>
                <Form.Label>Please choose up to four areas that you are wanting to work on:</Form.Label>

                <Grid
                  container
                  style={{
                    backgroundColor: "rgba(255,255,255,1)",
                    marginTop: 20,
                    paddingBottom: 15,
                  }}
                >
                  {/* Column 1 */}
                  <Grid item md={6} xs={12}>
                    <List className={classes.root}>
                      {PsychologyAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                        if (row.focusAreaIndex !== null && row.focusAreaIndex <= aoi_focus / 2) {
                          const labelId = `checkbox-list-label-${row.id}`;
                          var isChecked = checked.find((r) => r.id === row.id);
                          return (
                            <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                              <ListItemIcon style={{ minWidth: 40 }}>
                                <Checkbox
                                  edge="start"
                                  checked={isChecked !== undefined}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                style={{ fontSize: 12 }}
                                disableTypography
                                primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                className={classes.link}
                              />
                            </ListItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </List>
                  </Grid>

                  {/* Column 2 */}
                  <Grid item md={6} xs={12}>
                    <List className={classes.root}>
                      {PsychologyAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                        if (row.focusAreaIndex !== null && row.focusAreaIndex > aoi_focus / 2) {
                          const labelId = `checkbox-list-label-${row.id}`;
                          var isChecked = checked.find((r) => r.id === row.id);
                          return (
                            <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                              <ListItemIcon style={{ minWidth: 40 }}>
                                <Checkbox
                                  edge="start"
                                  checked={isChecked !== undefined}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                style={{ fontSize: 12 }}
                                disableTypography
                                primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                className={classes.link}
                              />
                            </ListItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </List>
                  </Grid>
                </Grid>

                {/* Need to get client address state if they checked any of the WWCC AOI */}
                {aoi_wwcc && checked && aoi_wwcc.filter((id) => checked.includes(id)).length > 0 ? (
                  <Alert severity="warning" style={{ marginTop: 15, fontSize: 12, fontWeight: 600 }}>
                    Please select which state you reside in so a qualified provider can be selected for you.
                    <Grid item md={6} xs={12} style={{ marginTop: 20 }}>
                      <Form.Group>
                        <Form.Control as="select" defaultValue={currentWWCCState} onChange={(event) => setCurrentWWCCState(event.target.value)}>
                          <option value="">Select your home State</option>
                          {wwcc && wwcc.map((wwcc) => <option value={wwcc.state}>{wwcc.state}</option>)}
                        </Form.Control>
                      </Form.Group>
                    </Grid>
                  </Alert>
                ) : null}

                <Form.Label style={{ marginTop: 20 }}>
                  Rural Health Connect is part of programs supporting key areas of need. Please tick any that apply to you.
                </Form.Label>

                <Grid
                  container
                  style={{
                    backgroundColor: "rgba(255,255,255,1)",
                    marginTop: 20,
                    paddingBottom: 15,
                  }}
                >
                  {/* Column 1 */}
                  <Grid item md={6} xs={12}>
                    <List className={classes.root}>
                      {PsychologyAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                        if (row.focusAreaIndex === null && row.index <= aoi_other / 2) {
                          const labelId = `checkbox-list-label-${row.id}`;
                          var isChecked = checked.find((r) => r.id === row.id);
                          return (
                            <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                              <ListItemIcon style={{ minWidth: 40 }}>
                                <Checkbox
                                  edge="start"
                                  checked={isChecked !== undefined}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                style={{ fontSize: 12 }}
                                disableTypography
                                primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                className={classes.link}
                              />
                            </ListItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </List>
                  </Grid>

                  {/* Column 2 */}
                  <Grid item md={6} xs={12}>
                    <List className={classes.root}>
                      {PsychologyAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                        if (row.focusAreaIndex === null && row.index > aoi_other / 2) {
                          const labelId = `checkbox-list-label-${row.id}`;
                          var isChecked = checked.find((r) => r.id === row.id);
                          return (
                            <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                              <ListItemIcon style={{ minWidth: 40 }}>
                                <Checkbox
                                  edge="start"
                                  checked={isChecked !== undefined}
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                style={{ fontSize: 12 }}
                                disableTypography
                                primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                className={classes.link}
                              />
                            </ListItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </List>
                  </Grid>
                </Grid>
              </Form.Group>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {props.providerType && props.providerType === "Provisional" ? (
            <>
              <Row>
                <Col md="12">
                  <h2>1. Areas of Interest</h2>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  {props.steps.message ? (
                    <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                      {props.steps.message}
                    </Alert>
                  ) : null}
                </Col>
              </Row>
              <hr style={{ marginTop: 4 }}></hr>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      Please tell us if you are part of any of these key target groups for our support, and then nominate what you are wanting to work on,
                      below:
                    </Form.Label>

                    <Grid
                      container
                      style={{
                        backgroundColor: "rgba(255,255,255,1)",
                        marginTop: 20,
                        paddingBottom: 15,
                      }}
                    >
                      {/* Column 1 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {ProvisionalAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.focusAreaIndex !== null && row.focusAreaIndex <= aoi_focus / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>

                      {/* Column 2 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {ProvisionalAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.focusAreaIndex !== null && row.focusAreaIndex > aoi_focus / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      style={{
                        backgroundColor: "rgba(255,255,255,1)",
                        marginTop: 20,
                        paddingBottom: 15,
                      }}
                    >
                      {/* Column 1 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {ProvisionalAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.focusAreaIndex === null && row.index <= aoi_other / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>

                      {/* Column 2 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {ProvisionalAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.focusAreaIndex === null && row.index > aoi_other / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>
                    </Grid>
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col md="12">
                  <h2>1. Locations</h2>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                    <p>
                      This is currently a pilot covering Southern Queensland, Gippsland and North East Victoria only as part of bushfire recovery efforts, it is
                      open to any resident in these regions. If you are outside these areas and would like to speak to a financial counsellor please call 1300
                      771 741.
                    </p>
                    <p>
                      Sessions are free of charge and are funded by the Commonwealth Department of Agriculture and the Victorian and Queensland Governments.
                    </p>
                    <p>
                      There are different financial counsellors for people in different situations: "<strong>Primary Producer</strong>" counselling is for
                      farmers, "<strong>Small Business</strong>" counselling is for small business operations and "<strong>Individual</strong>" is for people
                      wanting help with their personal finances.
                    </p>
                    <p>Please choose the option and location right for you.</p>
                  </Alert>
                </Col>
              </Row>
              <hr style={{ marginTop: 4 }}></hr>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Please select the type of counsellor and the location that is right for you.</Form.Label>

                    <Grid
                      container
                      style={{
                        backgroundColor: "rgba(255,255,255,1)",
                        marginTop: 20,
                        paddingBottom: 15,
                      }}
                    >
                      {/* Column 1 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {FinancialAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.index <= aoi_other / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>

                      {/* Column 2 */}
                      <Grid item md={6} xs={12}>
                        <List className={classes.root}>
                          {FinancialAreasOfInterest.filter((aoi) => aoi.psychologistsCount > 0).map((row) => {
                            if (row.index > aoi_other / 2) {
                              const labelId = `checkbox-list-label-${row.id}`;
                              var isChecked = checked.find((r) => r.id === row.id);
                              return (
                                <ListItem key={row.id} role={undefined} dense button onClick={handleToggle(row)}>
                                  <ListItemIcon style={{ minWidth: 40 }}>
                                    <Checkbox
                                      edge="start"
                                      checked={isChecked !== undefined}
                                      tabIndex={-1}
                                      disableRipple
                                      inputProps={{
                                        "aria-labelledby": labelId,
                                      }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    id={labelId}
                                    style={{ fontSize: 12 }}
                                    disableTypography
                                    primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.issue}</Typography>}
                                    className={classes.link}
                                  />
                                </ListItem>
                              );
                            } else {
                              return null;
                            }
                          })}
                        </List>
                      </Grid>
                    </Grid>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
      {aoiError && (
        <Row>
          <Col md="12">
            <Alert severity="error" style={{ marginBottom: 10 }}>
              {aoiError}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col md="12">
          <Grid container direction="row" justifyContent="space-between">
            <Grid item md={3} xs={6}></Grid>
            <Grid item md={2} xs={6} style={{ textAlign: "right" }}>
              {aoi_wwcc && checked && aoi_wwcc.filter((id) => checked.includes(id)).length > 0 && currentWWCCState === "" ? (
                <Button variant="primary" type="button" disabled={true} onClick={() => submitAOI()}>
                  Please select your home State
                </Button>
              ) : (
                <Button variant="primary" type="submit" onClick={() => submitAOI()}>
                  Save &amp; Next &gt;
                </Button>
              )}
            </Grid>
          </Grid>
        </Col>
      </Row>
    </Paper>
  );
}

const PopulateProviders = ({ steps, setStepValue }) => {
  const { values } = useFormikContext();

  useEffect(() => {
    if (!steps?.step2 || !setStepValue) return;

    const current = steps.step2;
    const updates = {};

    if (values.reducedGapReason !== "" && values.reducedGapReason !== current.reducedGapReason) {
      updates.reducedGapReason = values.reducedGapReason;
    }

    if (values.bulkBilledReason !== "" && values.bulkBilledReason !== current.bulkBilledReason) {
      updates.bulkBilledReason = values.bulkBilledReason;
    }

    if (values.paymenttype !== "" && values.paymenttype !== current.paymenttype) {
      updates.paymenttype = values.paymenttype;
    }

    if (values.paymenttype !== "" && values.healthCareCard !== current.healthCareCard) {
      updates.healthCareCard = values.healthCareCard;
    }

    if (Object.keys(updates).length > 0) {
      setStepValue({
        step2: {
          ...current,
          ...updates,
        },
      });
    }
  }, [values.paymenttype, values.healthCareCard, values.reducedGapReason, values.bulkBilledReason, steps?.step2, setStepValue]);

  return null;
};

function SelectPsychologist(props) {
  const dispatch = useDispatch();
  const { invitetoken } = useParams();
  const { eapToken } = useParams();
  const registered = useSelector((state) => state.registration.Registered);
  const registeredFetch = useSelector((state) => state.registration.RegisteredFetch);
  const matchingAvailability = useSelector((state) => state.registration.MatchingAvailability);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const invite = useSelector((state) => state.registration.ClientInvite);
  const searchAOI = [...props.steps.step1.search];
  const filters = useSelector((state) => state.admin.Filters);
  var [programBulkBilling] = useState(props.steps.step2.program);
  var [programid] = useState(props.steps.step2.programid);
  var [homeState] = useState(props.steps.step2.homeState);
  var [currentTimeZone, setcurrentTimeZone] = useState(props.steps.step2.userTZ ? props.steps.step2.userTZ : props.userTZ && props.userTZ.systemName);
  var [currentPsychologist, setcurrentPsychologist] = useState({
    ...props.steps.step2.data,
  });
  var [showNewBooking, setShowNewBooking] = useState(false);
  var [currentbookingdate, setcurrentbookingdate] = useState(props.steps.step2.bookingdate);
  var [showpopoverTimeZone, setshowpopoverTimeZone] = useState(!props.steps.step2.userTZ);
  // Need to ensure only providers who have Children (under 12) and Adolescents (13-17) AOI are shown - no one else so setting a flag to do this
  const childModeAOI = ["Children (under 12)", "Adolescents (13-17)"];
  var [childMode, setChildMode] = useState(
    props.steps.step1.data && props.steps.step1.data.filter((aoi) => childModeAOI.includes(aoi.issue)).length > 0 ? true : false,
  );
  // var [bookingConfirmed, setbookingConfirmed] = useState(!!props.steps.step2.bookingdate);
  const supervisionAreas = useSelector((state) => state.reference.SupervisionAreas).filter((sa) => sa.providertype === "Psychologist");
  const endorsedSupervisionAreas = useSelector((state) => state.reference.SupervisionAreas).filter((sa) => sa.providertype === "Psychologist-Endorsed");
  var [providerType] = useState(props.steps.step2.providerType);
  const [previousPaymentType, setPreviousPaymentType] = useState("");
  const [previousReducedGapReason, setPreviousReducedGapReason] = useState("");
  const [previousBulkBilledReason, setPreviousBulkBilledReason] = useState("");
  // const [displayContactForm,setDisplayContactForm] = useState(false);
  const [displayNoProvisionalMessage, setDisplayNoProvisionalMessage] = useState(false);
  const [expanded, setExpanded] = useState(0);
  const [showProviderBio, setShowProviderBio] = useState(false);
  const [providerBioFullName, setProviderBioFullName] = useState();
  const [providerBioBio, setProviderBioBio] = useState();
  const [showMoreProviders, setShowMoreProviders] = useState(false);

  // now init the fields with values so that Formik can manage the touched state
  const clientInit = {
    firstname: "",
    preferredname: "",
    surname: "",
    email: "",
    phone: "",
    clientFundingTypeID: 1,
    dob: undefined,
    gender: "",
    occupation: "",
    fulladdress: "",
    latitude: "",
    longitude: "",
    postcode: "",
    timezone: props.steps.step2.userTZ,
    clientAreasOfInterest: [...props.steps.step1.data],
    hopeToGetFromTreatment: "",
    emergencycontactname1: "",
    emergencycontactphone1: "",
    emergencycontactrelation1: "",
    emergencycontactname2: "",
    emergencycontactphone2: "",
    emergencycontactrelation2: "",
    profilePassword: "",
    profilePasswordConfirmation: "",
    medicareno: "",
    medicarereferenceno: "",
    medicareexpirydate: "",
    appointmenttype: "0",
    MHCPFile: "",
    invitetoken: invitetoken,
    eapToken: eapToken,
    agreementAcceptance: false,
    clientid: null,
    paymenttype: invitetoken && invitetoken.paymenttype ? invitetoken.paymenttype : "",
    privateClient: false,
    referrerid: null,
    abn: "",
    businessName: "",
    businessAddress: "",
    backgroundinformation: "",
    gpname: "",
    gpmentalhealthplan12months: "N/A",
    gpclinicname: "",
    healthCareCard: invitetoken && invitetoken.paymenttype === "Bulk Billed" ? "Y" : "",
    unemployed: "NA",
    naturalDisaster: "NA",
    bulkBilledReason: "",
    contract: false,
    providerType: props.providerType,
    locality: "",
    programid: 0,
  };

  const handleExpandClick = (id) => {
    if (id === expanded) {
      setExpanded(0);
    } else {
      setExpanded(id);
    }
  };

  // const handleExpandPricingDetailClick = (id) => {
  //   if(id === expandPricingDetail) {
  //     setExpandPricingDetail(0)
  //   } else {
  //     setExpandPricingDetail(id);
  //   }
  // };

  useEffect(() => {
    dispatch(
      Registration.actions.fetchMatchingAvailability({
        psychologistID: currentPsychologist.id,
        userTZ: currentTimeZone,
        providerType: providerType,
        invitetoken: programid && programid === 1 ? "pgnl" : invitetoken,
      }),
    );
  }, [dispatch, currentPsychologist, currentTimeZone, providerType, props.invitetoken, invitetoken]);

  const searchPsychologist = (p) => {
    if (
      true &&
      // if there is AOI selections, then return if number of matches in psychologist equals the number of options in the selection
      (!searchAOI ||
        (searchAOI && searchAOI.length === 0) ||
        (searchAOI && searchAOI.filter(({ issue }) => p.areasOfInterest.includes(issue)).length === searchAOI.length)) &&
      // search fullname for search string
      (p.id === currentPsychologist.id || currentPsychologist.id === undefined) &&
      // Note the contractid 11 reference below is related to the NthQLDPHN project - if the client registering is part of this project then any providertype will do
      ((invite && invite.contractid === 11) ||
        props.steps.step2.providerType === "NthQLDPHN" ||
        props.steps.step2.providerType === "ALL" ||
        (props.steps.step2.providerType !== "Psychologist" && p.providertype === props.steps.step2.providerType) ||
        (props.steps.step2.providerType === "Psychologist" &&
          (p.providertype === "Clinical" || p.providertype === "Psychologist" || p.providertype === "Occupational")))
    ) {
      return p;
    }
  };

  const searchAllPsychologist = (p) => {
    if (
      true &&
      // Check not in FilteredPsychologists
      (!filteredPsychologists ||
        (filteredPsychologists && filteredPsychologists.length === 0) ||
        (filteredPsychologists && filteredPsychologists.filter(({ id }) => p.id === id).length === 0))
    ) {
      return p;
    }
  };

  const searchAOISpecificPsychologist = (p) => {
    if (
      true &&
      // if there is AOI selections, then return if number of matches in psychologist equals the number of options in the selection
      (!searchAOI ||
        (searchAOI && searchAOI.length === 0) ||
        (searchAOI && searchAOI.filter(({ issue }) => p.areasOfInterest.includes(issue)).length === searchAOI.length)) &&
      // search years experience
      // && (p.experience > parseInt(searchExperience) || parseInt(searchExperience) === 0)
      // search fullname for search string
      (p.id === currentPsychologist.id || currentPsychologist.id === undefined) &&
      ((props.steps.step2.providerType !== "Psychologist" && p.providertype === props.steps.step2.providerType) ||
        props.steps.step2.providerType === "ALL" ||
        (props.steps.step2.providerType === "Psychologist" &&
          (p.providertype === "Clinical" || p.providertype === "Psychologist" || p.providertype === "Occupational")))
    ) {
      return p;
    }
  };

  const searchWWCCSpecificPsychologist = (p) => {
    if (
      true &&
      // if there is AOI selections, then return if number of matches in psychologist equals the number of options in the selection
      (!searchAOI ||
        (searchAOI && searchAOI.length === 0) ||
        (searchAOI && searchAOI.filter(({ issue }) => p.areasOfInterest.includes(issue)).length === searchAOI.length)) &&
      // Ensure the provider has a WWCC State the same as the client homeState
      homeState &&
      p.wwcc.find((wwcc) => wwcc.state === homeState) &&
      (p.id === currentPsychologist.id || currentPsychologist.id === undefined) &&
      ((props.steps.step2.providerType !== "Psychologist" && p.providertype === props.steps.step2.providerType) ||
        props.steps.step2.providerType === "ALL" ||
        (props.steps.step2.providerType === "Psychologist" &&
          (p.providertype === "Clinical" || p.providertype === "Psychologist" || p.providertype === "Occupational")))
    ) {
      return p;
    }
  };

  function compareAoiCount(a, b) {
    if (a.aoiCount < b.aoiCount) {
      return 1;
    }
    if (a.aoiCount > b.aoiCount) {
      return -1;
    }
    return 0;
  }

  function compareStandardCost(a, b) {
    var partA = parseFloat(a.standardFeeOutOfPocket.substring(1, a.standardFeeOutOfPocket.length - 1));
    var partB = parseFloat(b.standardFeeOutOfPocket.substring(1, b.standardFeeOutOfPocket.length - 1));
    if (partA > partB) {
      return 1;
    }
    if (partA < partB) {
      return -1;
    }
    return 0;
  }

  function compareReducedCost(a, b) {
    var partA = parseFloat(a.reducedFeeOutOfPocket.substring(1, a.reducedFeeOutOfPocket.length - 1));
    var partB = parseFloat(b.reducedFeeOutOfPocket.substring(1, b.reducedFeeOutOfPocket.length - 1));
    if (partA > partB) {
      return 1;
    }
    if (partA < partB) {
      return -1;
    }
    return 0;
  }

  // (props.steps.step2.paymenttype === "Bulk Billed" && row.bulkBillingAvailable === "0" && !props.steps.step2.program) ?

  function compareBulkBillingNextAvailable(a, b) {
    if (a.bulkBillingAvailable === "1" && b.bulkBillingAvailable === "0") {
      return -1;
    }
    if ((a.bulkBillingAvailable === "0" || props.steps.step2.program) && b.bulkBillingAvailable === "1") {
      return 1;
    }
    return 0;
  }

  // nextAvailable
  // function compareNextAvailable( a, b ) {
  //  console.log(a.nextAvailable)
  //   var partsA = a.nextAvailable.split("/");
  //   var dateA = new Date(parseInt(partsA[2], 10),
  //                     parseInt(partsA[1], 10) - 1,
  //                     parseInt(partsA[0], 10)).getTime()
  //  console.log(dateA)

  //  console.log(b.nextAvailable)
  //   var partsB = b.nextAvailable.split("/");
  //   var dateB = new Date(parseInt(partsB[2], 10),
  //                     parseInt(partsB[1], 10) - 1,
  //                     parseInt(partsB[0], 10)).getTime()
  //  console.log(dateB)
  //   return dateA > dateB ? 1 : -1;
  //   // return 0;
  // }

  // var filteredPsychologists = registered.filter(p => searchPsychologist(p))
  const temp = registered.map((row) => {
    return {
      aoiCount: row.areasOfInterest.filter((issue) => searchAOI.some((aoi) => aoi.issue === issue)).length,
      ...row,
    };
  });
  // If fixAOI is set then only match on that AOI - nothing else

  // Some documentation about the ever growing complexity of the provider order
  // Condition 1 - If the ProviderType is EAP then display all Providers with availability -- removed 2025-05-29
  // Condition 2 - If the type is fixAOI (i.e. Perinatal Loss etc.) then only match on that AOI - nothing else
  // Condition 3 - if sort order filter (clientRegistrationSort) set to cost and payment type is Full Fee then sort by standard cost
  // Condition 4 - if sort order filter (clientRegistrationSort) set to cost and payment type is Reduced Gap then sort by reduced cost
  // Condition 5 - Regardless of sort order selection, if payment type is set to Bulk Billed then sort by Next Availabile prioritizing those with Bulk Billing availablity
  // Condition 6 - Default Sort Order (i.e. Next Available) then do the usual
  //

  // console.log(props.steps.step1)
  // console.log(props.steps.step2)

  // EAP changed on 2025-05-29 to allow all providers
  var filteredPsychologists =
    providerType === "EAP"
      ? temp.sort(compareBulkBillingNextAvailable).filter((p) => searchPsychologist(p))
      : childMode
        ? registered.filter((p) => searchWWCCSpecificPsychologist(p))
        : props.steps.step2.fixAOI
          ? registered.filter((p) => searchAOISpecificPsychologist(p))
          : filters.clientRegistrationSort === "Cost" && props.steps.step2.paymenttype === "Full Fee"
            ? temp.sort(compareStandardCost).filter((p) => searchPsychologist(p))
            : filters.clientRegistrationSort === "Cost" && props.steps.step2.paymenttype === "Reduced Gap"
              ? temp.sort(compareReducedCost).filter((p) => searchPsychologist(p))
              : filters.clientRegistrationSort === "Cost" && props.steps.step2.paymenttype === "Bulk Billed"
                ? temp.sort(compareBulkBillingNextAvailable).filter((p) => searchPsychologist(p))
                : filters.clientRegistrationSort === "NextAvailable" && props.steps.step2.paymenttype === "Bulk Billed"
                  ? temp.sort(compareBulkBillingNextAvailable).filter((p) => searchPsychologist(p))
                  : temp
                      .sort((a, b) => a.nextAvailableSort.localeCompare(b.nextAvailableSort))
                      .sort(compareAoiCount)
                      .filter((p) => searchPsychologist(p));

  // Gather all providers that are not in the filtered list
  var validPsychologists = registered.filter((p) => searchAllPsychologist(p));

  // console.log(temp)
  useEffect(() => {
    // console.log('In Use Effect')
    // console.log('Valid Psychologists')
    // console.log(validPsychologists)
    // console.log('Registered')
    // console.log(registered)
    // console.log('Search')
    // console.log(props.steps.step1.search)

    if (filteredPsychologists.length < 1 && registered.length > 0) {
      // If fixAOI is set then only match on that AOI - nothing else
      if (props.steps.step1.search.length > 0 && !props.steps.step2.fixAOI) {
        var newAOI = [...props.steps.step1.search];
        var existingAOI = [...props.steps.step1.data];
        // Before trimming off the last element need to ensure the last element is not a childModeAOI
        if (childMode) {
          if (childModeAOI.includes(newAOI[newAOI.length - 1].issue)) {
            // Ok the last element is a childModeAOI so we can't remove it
            // Are there more than two elements?
            if (newAOI.length > 1) {
              // Remove first element
              newAOI.shift();
            } else {
              // console.log('Child Mode On and nothing to remove')
              // console.log(newAOI)
              // console.log(existingAOI)
              // Advise client there are no qualifying providers for Children
              props.setStepValue({
                step2: {
                  ...props.steps.step2,
                  status: "Completed",
                  data: {},
                  bookingdate: null,
                  providerType: providerType,
                  userTZ: currentTimeZone,
                },
                currentStep: 6,
              });
              // console.log(props)
            }
          } else {
            newAOI.pop();
            props.setStepValue({
              step1: { status: "Completed", data: existingAOI, search: newAOI },
              currentStep: 2,
            });
          }
        } else {
          newAOI.pop();
          props.setStepValue({
            step1: { status: "Completed", data: existingAOI, search: newAOI },
            currentStep: 2,
          });
        }
      } else {
        // Ok we could not find a provider available regardless of the area of interest selection
        // Check if Provisional - we display a contact form for them
        if (providerType === "Provisional") {
          //setDisplayContactForm(true);
          setDisplayNoProvisionalMessage(true);
        }
        // May need to add these actions to all
      }
    }
    // Registered is fetching by provider type so it is possible there will be no registered response for Provisional
    if (filteredPsychologists.length < 1 && registeredFetch && registered.length === 0 && providerType === "Provisional") {
      //setDisplayContactForm(true);
      setDisplayNoProvisionalMessage(true);
    } else {
      setDisplayNoProvisionalMessage(false);
    }
  }, [filteredPsychologists, registered, props, providerType, registeredFetch]);

  // const handleExpandClick = (id) => {
  //   if(id === expanded) {
  //     setExpanded(0)
  //   } else {
  //     setExpanded(id);
  //   }
  // };

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      props.setStepValue({
        step2: {
          ...props.steps.step2,
          status: "In Progress",
          data: { ...currentPsychologist },
          bookingdate: undefined,
          providerType: providerType,
          userTZ: newValue.systemName,
        },
        currentStep: 2,
      });
      setcurrentTimeZone(newValue.systemName);
      setshowpopoverTimeZone(false);
    }
  }

  const submitPsychologist = () => {
    if (currentPsychologist.id !== undefined && currentbookingdate !== undefined) {
      props.setStepValue({
        step2: {
          ...props.steps.step2,
          status: "Completed",
          data: { ...currentPsychologist },
          bookingdate: currentbookingdate,
          providerType: providerType,
          userTZ: currentTimeZone,
        },
        currentStep: 3,
      });
    }
  };

  const isMobile = useMediaQuery("(max-width: 760px)");

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 240,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: "rotate(180deg)",
    },
  }));
  const classes = useStyles();

  // Blob setup for psychologist photos
  const containerName = `psychologists`;
  const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME || "";

  const startNewBooking = (bookingdate) => {
    setcurrentbookingdate(bookingdate);
    setShowNewBooking(true);
  };

  const saveAppointment = () => {
    // Need to consider this further - need to support removing appointments as well
    props.setStepValue({
      step2: {
        ...props.steps.step2,
        status: "Completed",
        data: { ...currentPsychologist },
        bookingdate: currentbookingdate,
        providerType: providerType,
        userTZ: currentTimeZone,
      },
      currentStep: 3,
    });
    setShowNewBooking(false);
  };

  const popoverTimeZone = (
    <Popover id="popover-basic" className="popover-instruction">
      <Popover.Title as="h3">TimeZone</Popover.Title>
      <Popover.Content>
        Next, <strong>select</strong> your timezone so that we can look up your Providers's availability.
      </Popover.Content>
    </Popover>
  );

  // const popoverBooking = (
  //   // !bookingConfirmed ?
  //   <Popover id="popover-basic" className="popover-instruction">
  //     <Popover.Title as="h3">Make a Booking</Popover.Title>
  //     <Popover.Content>
  //       You must select a timezone and make a booking to continue.
  //     </Popover.Content>
  //   </Popover>
  //   // :
  //   // <div id="popover-basic" style={{ display: 'none' }} className="popover-instruction">Here</div>
  // );

  var rowcount = 0; //count of bookings displayed

  // get the invite (if any) from state and merge with the initialised fields
  const inviteInit = useSelector((state) => state.registration.ClientInvite);
  const [clientInvite, setClientInvite] = useState({
    ...clientInit,
    ...inviteInit,
    steps: props.steps,
  });
  const [previousSteps, setPreviousSteps] = useState();

  useEffect(() => {
    if (previousSteps !== props.steps) {
      setClientInvite({
        ...clientInvite,
        steps: { ...props.steps },
        program: props.steps.step2.fixAOI,
        programid: props.steps.step2.programid,
        paymenttype: props.steps.step2.paymenttype,
        unemployed: props.steps.step2.unemployed,
        naturalDisaster: props.steps.step2.naturalDisaster,
        bulkBilledReason: props.steps.step2.bulkBilledReason,
        reducedGapReason: props.steps.step2.reducedGapReason,
        healthCareCard: props.steps.step2.paymenttype === "Bulk Billed" ? "Y" : "",
      });
      setPreviousSteps(props.steps);
    }
  }, [props.steps.step2, props.steps, providerType, previousSteps]);

  const validationSchema = Yup.object().shape({
    healthCareCard: Yup.string().when(["providerType", "paymenttype"], {
      is: (providerType, paymenttype) =>
        paymenttype === "Bulk Billed" && (providerType === "Clinical" || providerType === "Psychologist" || providerType === "Occupational"),
      then: Yup.string().oneOf(["Y", "N"]).required("Please advise if you have a Health Care Card"),
    }),
  });

  const moreProviderBio = (fullName, bio) => {
    setProviderBioFullName(fullName);
    setProviderBioBio(bio);
    setShowProviderBio(true);
  };

  function submitForm(data) {
    props.setStepValue({
      step2: {
        status: "In Progress",
        data: {},
        bookingdate: currentbookingdate,
        providerType: providerType,
        userTZ: currentTimeZone,
        paymenttype: data.paymenttype,
        healthCareCard: data.healthCareCard,
        unemployed: data.unemployed,
        naturalDisaster: data.naturalDisaster,
        bulkBilledReason: data.bulkBilledReason,
        reducedGapReason: data.reducedGapReason,
      },
      currentStep: 2,
    });
  }

  // function submitContactForm(data){
  //   dispatch(Registration.actions.postContactFormEntry(data))
  //   props.setStepValue({ step2: { ...props.steps.step2, status: 'Not Started', data: {}, bookingdate: null, providerType : providerType, userTZ: currentTimeZone }, currentStep: 5 })
  //   // setStatus('Submitted')
  // }

  // const contactForm = {
  //   firstname: '',
  //   surname: '',
  //   email: '',
  //   phone: '',
  //   locality: ''
  // }

  // const contactFormBValidationSchema = Yup.object().shape({
  //     firstname:  Yup.string()
  //     .min(2,"Too Short")
  //     .max(255,"Too Long")
  //     .required("First Name is required"),
  //     surname:  Yup.string()
  //     .min(2,"Too Short")
  //     .max(255,"Too Long")
  //     .required("Surname is required"),
  //     email: Yup.string()
  //     .min(2,"Too Short")
  //     .max(200,"Too Long")
  //     .email("Enter a valid email")
  //     .required("Email is required"),
  //     phone:  Yup.string()
  //     .min(2,"Too Short")
  //     .max(12,"Too Long")
  //     .required("Phone Number is required"),
  //     locality:  Yup.string()
  //     .min(2,"Too Short")
  //     .max(250,"Too Long")
  //     .required('Locality is required'),
  //   });

  if (displayNoProvisionalMessage) {
    return (
      <>
        <Paper style={{ padding: 20, backgroundColor: "rgb(245,245,245)" }}>
          <Row>
            <Col md="12">
              {providerType && providerType === "Financial" ? (
                <h2>2. Financial Counsellor</h2>
              ) : (
                <>
                  {providerType && providerType === "GP" ? (
                    <h2>2. GP</h2>
                  ) : (
                    <>
                      {providerType && providerType === "Provisional" ? (
                        <h2>2. Provisional Psychologist</h2>
                      ) : (
                        <>
                          {providerType && providerType === "Social" ? (
                            <h2>2. MH Social Worker</h2>
                          ) : (
                            <>
                              {providerType && providerType === "Nurse" ? (
                                <h2>2. Mental Health Nurse</h2>
                              ) : (
                                <>
                                  {providerType && providerType === "Occupational" ? (
                                    <h2>2. Occupational Therapist</h2>
                                  ) : (
                                    <>
                                      {providerType && providerType === "Supervision" ? (
                                        <h2>2. Supervising Psychologist</h2>
                                      ) : (
                                        <>{clientInvite && clientInvite.contract ? <h2>2. Practitioner</h2> : <h2>2. Practitioner</h2>}</>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Col>
          </Row>
          <hr style={{ marginTop: 4 }}></hr>
          <Alert
            severity="error"
            style={{
              backgroundColor: "#DAF3F4",
              borderColor: "#CEE6E7",
              marginBottom: 15,
            }}
          >
            <h4 style={{ marginBottom: 15 }}>The Rural Recovery Provisional Psychologist program is currently at capacity.</h4>
            <p>You can book a registered psychologist under a mental health treatment plan. </p>
            <p>
              Book a registered psychologist{" "}
              <a href={`https://portal.ruralhealthconnect.com.au/clientregistration/new`} style={{ textDecoration: "underline" }}>
                here.
              </a>
            </p>
            <p>
              Download Rural Health Connect flyer with referral information to show your GP{" "}
              <a
                href={`https://ruralhealthconnect.com.au/assets/RHC-client-flyer-V02.pdf`}
                target="ClientGPInformation"
                style={{ textDecoration: "underline" }}
              >
                here.
              </a>
            </p>
          </Alert>
          <hr style={{ marginTop: 4 }}></hr>
        </Paper>
      </>
    );
  }
  // No using the contact form at the moment - however it may be back later
  // if (displayContactForm)
  // {
  //   return(
  //     <>
  //       <Paper style={{ padding: 20, backgroundColor: "rgb(245,245,245)" }}>
  //         <Row>
  //           <Col md="12">
  //             {providerType && providerType === 'Financial' ?
  //               <h2>2. Financial Counsellor</h2>
  //             :
  //               <>
  //                 {providerType && providerType === 'GP' ?
  //                   <h2>2. GP</h2>
  //                 :
  //                   <>
  //                     {providerType && providerType === 'Provisional'?
  //                       <h2>2. Provisional Psychologist</h2>
  //                     :
  //                       <>
  //                         {providerType && providerType === 'Social'?
  //                           <h2>2. MH Social Worker</h2>
  //                         :
  //                           <>
  //                             {providerType && providerType === 'Occupational'?
  //                               <h2>2. Occupational Therapist</h2>
  //                             :
  //                               <h2>2. Psychologist</h2>
  //                             }
  //                           </>
  //                         }
  //                       </>
  //                     }
  //                   </>
  //                 }
  //               </>
  //             }
  //           </Col>
  //         </Row>
  //         <hr style={{ marginTop: 4 }}></hr>
  //         <Formik
  //           enableReinitialize={true}
  //           initialValues={contactForm}
  //           validationSchema = {contactFormBValidationSchema }
  //           onSubmit={(values, actions) => {
  //             submitContactForm(values);
  //             actions.setSubmitting(false);
  //           }}
  //         >
  //           {props => {
  //             const { values, errors, touched, handleChange, handleSubmit } = props;
  //             const change = (name,e) => { e.persist();  handleChange(e); };
  //             return (
  //               <form noValidate={true} autoComplete="off" onSubmit={handleSubmit} >
  //                 <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20, maxWidth: 800 }}>
  //                   {/* <Row>
  //                     <Col md="12">
  //                       <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
  //                         <Grid item md={9} xs={12}>
  //                           <h2>Referrer Registration of Interest Form</h2>
  //                         </Grid>
  //                         <Grid item md={3} xs={12} style={{ fontStyle: "italic", fontWeight: 400, textAlign: "right", paddingBottom: 4, fontSize: 12 }}>
  //                           * indicates required fields
  //                         </Grid>
  //                       </Grid>
  //                     </Col>
  //                   </Row>
  //                   <hr style={{ marginTop: 4 }}></hr> */}
  //                   <Alert  style={{ backgroundColor: "#DAF3F4", borderColor: "#CEE6E7", marginBottom: 15 }}>
  //                     <p>Unfortunately there are no appointments available at this time. If you would like someone to call you back to arrange an appointment please enter your details here and we will be in touch:</p>
  //                   </Alert>
  //                   <hr style={{ marginTop: 4 }}></hr>
  //                   <Row>
  //                     <Col md="4">
  //                       <Form.Group >
  //                         <Form.Label>First Name *</Form.Label>
  //                         <Form.Control type="text" name="firstname" value={values.firstname} onChange={change.bind(null, "firstname")} autoComplete='new-password' isInvalid={touched.firstname && !!errors.firstname} isValid={touched.firstname && !errors.firstname}/>
  //                         <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
  //                       </Form.Group>
  //                     </Col>
  //                     <Col md="4">
  //                       <Form.Group >
  //                         <Form.Label>Surname *</Form.Label>
  //                         <Form.Control type="text"  name="surname" value={values.surname} onChange={change.bind(null, "surname")}  autoComplete='new-password' isInvalid={touched.surname && !!errors.surname} isValid={touched.surname && !errors.surname}/>
  //                         <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
  //                       </Form.Group>
  //                     </Col>
  //                   </Row>
  //                   <Row>
  //                     <Col md="8">
  //                         <Form.Group >
  //                         <Form.Label>Email *</Form.Label>
  //                         <Form.Control type="text" name="email" value={values.email} onChange={change.bind(null, "email")} isInvalid={touched.email && !!errors.email} isValid={touched.email && !errors.email} autoComplete='new-password' />
  //                         <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
  //                         </Form.Group>
  //                     </Col>
  //                     <Col md="4">
  //                         <Form.Group >
  //                         <Form.Label>Phone Number *</Form.Label>
  //                         <Form.Control type="text" name="phone" value={values.phone} onChange={change.bind(null, "phone")} isInvalid={touched.phone && !!errors.phone} isValid={touched.phone && !errors.phone} autoComplete='new-password' />
  //                         <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
  //                         </Form.Group>
  //                     </Col>
  //                   </Row>
  //                   <Row>
  //                     <Col md="4">
  //                       <Form.Group>
  //                         <Form.Label>Locality *</Form.Label>
  //                         <Form.Control type="text" name="locality" value={values.locality} onChange={change.bind(null, "locality")} isInvalid={touched.locality && !!errors.locality} isValid={touched.locality && !errors.locality} autoComplete='new-password' />
  //                         <Form.Control.Feedback type="invalid">{errors.locality}</Form.Control.Feedback>
  //                       </Form.Group>
  //                     </Col>
  //                   </Row>
  //                   <Row>
  //                     <Col md="12">
  //                       <Grid container direction="row" justifyContent="space-between">
  //                         <Grid item md={3} xs={6}>

  //                         </Grid>
  //                         <Grid item md={1} xs={6}>
  //                           <Button variant="primary" type="submit" >
  //                             Submit
  //                           </Button>
  //                         </Grid>
  //                       </Grid>
  //                     </Col>
  //                   </Row>
  //                 </Paper>
  //               </form>
  //             )
  //           }}
  //         </Formik>
  //       </Paper>
  //     </>
  //   )
  // }
  else {
    return (
      <>
        <Paper style={{ padding: 20, backgroundColor: "rgb(245,245,245)" }}>
          <Row>
            <Col md="12">
              {providerType && providerType === "Financial" ? (
                <h2>2. Financial Counsellor</h2>
              ) : (
                <>
                  {providerType && providerType === "GP" ? (
                    <h2>2. GP</h2>
                  ) : (
                    <>
                      {providerType && providerType === "Provisional" ? (
                        <h2>2. Provisional Psychologist</h2>
                      ) : (
                        <>
                          {providerType && providerType === "Social" ? (
                            <h2>2. MH Social Worker</h2>
                          ) : (
                            <>
                              {providerType && providerType === "Nurse" ? (
                                <h2>2. Mental Health Nurse</h2>
                              ) : (
                                <>
                                  {providerType && providerType === "Occupational" ? (
                                    <h2>2. Occupational Therapist</h2>
                                  ) : (
                                    <>
                                      {providerType && providerType === "Supervision" ? (
                                        <h2>2. Supervising Psychologist</h2>
                                      ) : (
                                        <>{clientInvite && clientInvite.contract ? <h2>2. Practitioner</h2> : <h2>2. Practitioner</h2>}</>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Col>
          </Row>
          <hr style={{ marginTop: 4 }}></hr>
          <Formik
            enableReinitialize={true}
            initialValues={clientInvite}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              submitForm(values);
              // actions.setSubmitting(false);
            }}
          >
            {(props) => {
              const { values, errors, touched, handleChange, handleSubmit } = props;
              const change = (name, e) => {
                e.persist();
                handleChange(e);
              };
              return (
                <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                  <PopulateProviders steps={props.steps} setStepValue={props.setStepValue} />
                  {providerType &&
                  (providerType === "ALL" ||
                    providerType === "Psychologist" ||
                    providerType === "Nurse" ||
                    providerType === "Social" ||
                    providerType === "Occupational" ||
                    providerType === "Clinical") &&
                  !clientInvite.contract ? (
                    <>
                      <Row>
                        <Col md="12">
                          <Form.Group>
                            {!programBulkBilling ? (
                              <>
                                <Form.Label style={{ fontWeight: 500 }}>Payment Options</Form.Label>
                                <p>
                                  We want everyone be able to access a provider and therefore have a range of pricing options. Reduced fee places are limited so
                                  please only apply if it suits your circumstances:
                                </p>
                                <Form.Check id="payment-fullfee" name="paymenttype" type="radio" style={{ marginBottom: 8 }}>
                                  <Form.Check.Input
                                    name="paymenttype"
                                    type="radio"
                                    value="Full Fee"
                                    checked={values.paymenttype === "Full Fee" ? true : false}
                                    onChange={change.bind(null, "paymenttype")}
                                  />
                                  <Form.Check.Label style={{ marginLeft: 12 }}>
                                    STANDARD FEE: I am employed and/or am not experiencing financial hardship{" "}
                                  </Form.Check.Label>
                                </Form.Check>
                                <Form.Check id="payment-reducedgap" name="paymenttype" type="radio" style={{ marginBottom: 8 }}>
                                  <Form.Check.Input
                                    name="paymenttype"
                                    type="radio"
                                    value="Reduced Gap"
                                    checked={values.paymenttype === "Reduced Gap" ? true : false}
                                    onChange={change.bind(null, "paymenttype")}
                                  />
                                  <Form.Check.Label style={{ marginLeft: 12 }}>
                                    REDUCED FEE: I am experiencing financial hardship and would like to apply for the psychologist's reduced gap fee
                                    option.{" "}
                                  </Form.Check.Label>
                                </Form.Check>
                                {values.paymenttype === "Reduced Gap" ? (
                                  <>
                                    <Row>
                                      <Col md="12">
                                        <Form.Group>
                                          <Form.Label>Please tell us about your circumstances in a few sentences</Form.Label>
                                          <Form.Control
                                            as="textarea"
                                            rows={4}
                                            type="text"
                                            name="reducedGapReason"
                                            value={values.reducedGapReason}
                                            onChange={change.bind(null, "reducedGapReason")}
                                            isInvalid={touched.reducedGapReason && !!errors.reducedGapReason}
                                            isValid={touched.reducedGapReason && !errors.reducedGapReason}
                                            autoComplete="new-password"
                                          />
                                          <Form.Control.Feedback type="invalid">{errors.reducedGapReason}</Form.Control.Feedback>
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                  </>
                                ) : null}
                              </>
                            ) : (
                              <>
                                <Form.Label style={{ fontWeight: 500 }}>Please select your practitioner below</Form.Label>
                                <p>
                                  This service is available to anyone impacted by perinatal loss, including all family members and those whose experience is
                                  historical. All sessions are bulk billed
                                </p>
                              </>
                            )}
                            <Form.Check id="payment-bulkbilled" name="paymenttype" type="radio" style={{ marginBottom: 8 }}>
                              <Form.Check.Input
                                name="paymenttype"
                                type="radio"
                                value="Bulk Billed"
                                checked={values.paymenttype === "Bulk Billed" ? true : false}
                                onChange={change.bind(null, "paymenttype")}
                              />
                              <Form.Check.Label style={{ marginLeft: 12 }}>
                                ​BULK BILL{" "}
                                {programBulkBilling === true
                                  ? null
                                  : "(limited sessions available) We have some bulk billed sessions available for those most in need. For Healthcare, Pension or Disability card holders only."}{" "}
                              </Form.Check.Label>
                            </Form.Check>
                            {values.paymenttype === "Bulk Billed" && !programBulkBilling ? (
                              <>
                                <Row>
                                  <Col md="12">
                                    <Form.Group>
                                      <Form.Label>Please tell us about your circumstances in a few sentences</Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        type="text"
                                        name="bulkBilledReason"
                                        value={values.bulkBilledReason}
                                        onChange={change.bind(null, "bulkBilledReason")}
                                        isInvalid={touched.bulkBilledReason && !!errors.bulkBilledReason}
                                        isValid={touched.bulkBilledReason && !errors.bulkBilledReason}
                                        autoComplete="new-password"
                                      />
                                      <Form.Control.Feedback type="invalid">{errors.bulkBilledReason}</Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </>
                            ) : null}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <Grid container direction="row" justifyContent="space-between">
                            <Grid item md={3} xs={6}></Grid>
                            <Grid item md={2} xs={6} style={{ textAlign: "right" }}>
                              <Button variant="primary" type="submit">
                                {values.steps.step2.status === "Not Started" ? "Save & Next" : "Update"}
                              </Button>
                            </Grid>
                          </Grid>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <>
                      {providerType && providerType === "Supervision" ? (
                        <>
                          <hr style={{ marginTop: 4 }}></hr>
                          <Alert
                            severity="info"
                            style={{
                              backgroundColor: "#DAF3F4",
                              borderColor: "#CEE6E7",
                              marginBottom: 15,
                            }}
                          >
                            <h5 style={{ marginBottom: 15 }}>
                              Any income generated by Rural Health Connect through this program goes directly to programs supporting disaster impacted rural
                              Australians. Thank you for being part of this.
                            </h5>
                          </Alert>
                          <hr style={{ marginTop: 4 }}></hr>
                        </>
                      ) : null}
                    </>
                  )}
                </form>
              );
            }}
          </Formik>
          <hr style={{ marginTop: 20, marginBottom: 20 }}></hr>
          <Row>
            <Col md="12">
              {props.steps.message ? (
                <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                  {props.steps.message}
                </Alert>
              ) : null}
            </Col>
          </Row>
          {providerType && providerType !== "EAP" && providerType !== "NthQLDPHN" && providerType !== "Contract" ? (
            <Row>
              <Col md="12" style={{ marginBottom: 20 }}>
                <Grid container direction="row" justifyContent="space-between">
                  <Grid item md={2} xs={6}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <FormLabel id="clientRegistrationSort-label" component="legend" style={{ fontWeight: 500 }}>
                        Sort By
                      </FormLabel>
                      <RadioGroup
                        aria-label="SortBy"
                        name="clientRegistrationSort"
                        value={filters.clientRegistrationSort}
                        onChange={(event) =>
                          dispatch(
                            Admin.actions.setFilters({
                              filterName: "clientRegistrationSort",
                              filterValue: event.target.value,
                            }),
                          )
                        }
                      >
                        <FormControlLabel value="NextAvailable" control={<Radio />} label="Next Available" />
                        <FormControlLabel value="Cost" control={<Radio />} label="Out of Pocket Cost" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Col>
            </Row>
          ) : null}
          <hr style={{ marginTop: 5, marginBottom: 5 }}></hr>

          <Grid container spacing={3}>
            {/* {!currentPsychologist  ? */}
            <Grid item md={currentPsychologist.id !== undefined ? 4 : 12} style={{ width: "100%" }}>
              <Masonry
                breakpointCols={isMobile || currentPsychologist.id !== undefined ? 1 : 3}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {filteredPsychologists.map((row, index) => {
                  return (
                    <Card className={classes.root} variant="outlined" key={index}>
                      <CardMedia
                        className={classes.media}
                        image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                        title="Psychologist"
                      />
                      {providerType && providerType === "Financial" ? (
                        <>
                          {/* Financial Counsellor Output */}
                          <CardContent>
                            <Grid container justifyContent="space-between">
                              <Grid item sm={9}>
                                <Typography variant="h5" component="h3">
                                  {row.fullname}
                                </Typography>
                              </Grid>
                              <Grid item sm={3} style={{ textAlign: "right" }}>
                                <Typography variant="subtitle1">{row.practicename}</Typography>
                              </Grid>
                            </Grid>
                            <Grid container style={{ marginBottom: 15, marginTop: 10 }}>
                              {row.areasOfInterest.map((row) => {
                                return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                              })}
                            </Grid>
                            <Grid container style={{ height: 220 }}>
                              <Typography variant="body2" component="p">
                                <Interweave content={row.bio} />
                                {/* {row.bio.substring(0,700)} */}
                                {row.bio.length > 700 ? (
                                  <>
                                    ...
                                    <Badge
                                      variant="secondary"
                                      onClick={() => moreProviderBio(row.fullname, row.bio)}
                                      style={{
                                        marginRight: 5,
                                        cursor: "pointer",
                                      }}
                                    >
                                      more
                                    </Badge>
                                  </>
                                ) : null}
                              </Typography>
                            </Grid>
                          </CardContent>
                        </>
                      ) : (
                        <>
                          {providerType &&
                          (providerType === "GP" || providerType === "EAP" || providerType === "Provisional" || providerType === "Supervision") ? (
                            <>
                              {/* GP, EAP, Supervision or Provisional Output i.e. no AOI */}
                              <CardContent>
                                <Grid container justifyContent="space-between">
                                  <Grid item sm={9}>
                                    <Typography variant="h5" component="h3">
                                      {row.fullname}
                                    </Typography>
                                    <Typography variant="subtitle1">{row.providerdescription}</Typography>
                                    {clientInvite && clientInvite.facetoFaceBooking === "Y" ? (
                                      <Typography variant="subtitle2">{row.fulladdress}</Typography>
                                    ) : (
                                      <Typography variant="subtitle2">
                                        {row.appointmentType === "BOTH"
                                          ? "Appointments are via Video or Phone call"
                                          : row.appointmentType === "PHONE"
                                            ? "Appointments are via Phone call"
                                            : "Appointments are via Video call"}
                                      </Typography>
                                    )}
                                    <Typography variant="subtitle2" style={{ marginTop: 20 }}>
                                      {`(Next Available Booking: ${row.nextAvailable})`}
                                    </Typography>
                                  </Grid>
                                </Grid>
                                {providerType && providerType === "Supervision" ? (
                                  <>
                                    <Grid container style={{ marginTop: 10 }}>
                                      <Grid item sm={6}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          Out of Pocket Cost
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={6} style={{ textAlign: "right" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          {row.hourlyrate}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </>
                                ) : null}
                                <Grid container style={{ marginTop: 10 }}>
                                  <Typography variant="body2" component="p">
                                    {/* {row.bio.substring(0,700)} */}
                                    <Interweave content={row.bio} />
                                    {row.bio.length > 700 ? (
                                      <>
                                        ...
                                        <Badge
                                          variant="secondary"
                                          onClick={() => moreProviderBio(row.fullname, row.bio)}
                                          style={{
                                            marginRight: 5,
                                            cursor: "pointer",
                                          }}
                                        >
                                          more
                                        </Badge>
                                      </>
                                    ) : null}
                                  </Typography>
                                </Grid>
                                {providerType && providerType === "Supervision" ? (
                                  <>
                                    <Typography variant="h6" component="h3" style={{ paddingTop: 20 }}>
                                      Available For
                                    </Typography>
                                    <Row>
                                      <Col md="6">
                                        <List className={classes.root}>
                                          {supervisionAreas.map((sRow) => {
                                            if (sRow.index <= supervisionAreas.length / 2) {
                                              const labelId = `checkbox-list-label-${sRow.id}`;
                                              var isChecked = row.supervisorAreas.includes(sRow.id);
                                              return (
                                                <ListItem key={sRow.id} role={undefined} dense button>
                                                  <ListItemIcon style={{ minWidth: 40 }}>
                                                    <Checkbox
                                                      edge="start"
                                                      checked={isChecked}
                                                      tabIndex={-1}
                                                      disableRipple
                                                      inputProps={{
                                                        "aria-labelledby": labelId,
                                                      }}
                                                    />
                                                  </ListItemIcon>
                                                  <ListItemText
                                                    id={labelId}
                                                    style={{ fontSize: 12 }}
                                                    disableTypography
                                                    primary={<Typography className={isChecked ? classes.linkSelected : classes.link}>{sRow.issue}</Typography>}
                                                    className={classes.link}
                                                  />
                                                </ListItem>
                                              );
                                            } else {
                                              return null;
                                            }
                                          })}
                                        </List>
                                      </Col>
                                      <Col md="6">
                                        <List className={classes.root}>
                                          {supervisionAreas.map((sRow) => {
                                            if (sRow.index > supervisionAreas.length / 2) {
                                              const labelId = `checkbox-list-label-${sRow.id}`;
                                              var isChecked = row.supervisorAreas.includes(sRow.id);
                                              return (
                                                <ListItem key={sRow.id} role={undefined} dense button>
                                                  <ListItemIcon style={{ minWidth: 40 }}>
                                                    <Checkbox
                                                      edge="start"
                                                      checked={isChecked}
                                                      tabIndex={-1}
                                                      disableRipple
                                                      inputProps={{
                                                        "aria-labelledby": labelId,
                                                      }}
                                                    />
                                                  </ListItemIcon>
                                                  <ListItemText
                                                    id={labelId}
                                                    style={{ fontSize: 12 }}
                                                    disableTypography
                                                    primary={<Typography className={isChecked ? classes.linkSelected : classes.link}>{sRow.issue}</Typography>}
                                                    className={classes.link}
                                                  />
                                                </ListItem>
                                              );
                                            } else {
                                              return null;
                                            }
                                          })}
                                        </List>
                                      </Col>
                                    </Row>
                                    <Typography variant="h6" component="h3" style={{ paddingTop: 20 }}>
                                      Endorsed In
                                    </Typography>
                                    <Row>
                                      <Col md="6">
                                        <List className={classes.root}>
                                          {endorsedSupervisionAreas.map((sRow) => {
                                            var isChecked = row.supervisorAreas.includes(sRow.id);
                                            const labelId = `checkbox-list-label-${sRow.id}`;
                                            if (isChecked) {
                                              return (
                                                <ListItem key={sRow.id} role={undefined} dense button>
                                                  <ListItemIcon style={{ minWidth: 40 }}>
                                                    <Checkbox
                                                      edge="start"
                                                      checked={isChecked}
                                                      tabIndex={-1}
                                                      disableRipple
                                                      inputProps={{
                                                        "aria-labelledby": labelId,
                                                      }}
                                                    />
                                                  </ListItemIcon>
                                                  <ListItemText
                                                    id={labelId}
                                                    style={{ fontSize: 12 }}
                                                    disableTypography
                                                    primary={<Typography className={isChecked ? classes.linkSelected : classes.link}>{sRow.issue}</Typography>}
                                                    className={classes.link}
                                                  />
                                                </ListItem>
                                              );
                                            } else {
                                              return null;
                                            }
                                          })}
                                        </List>
                                      </Col>
                                    </Row>
                                  </>
                                ) : null}
                              </CardContent>
                            </>
                          ) : (
                            <>
                              {/* Psychologist, Social, Occupation, Nurse and Clinical Output */}
                              <CardContent>
                                <Grid container justifyContent="space-between">
                                  <Grid item sm={9}>
                                    <Typography variant="h5" component="h3">
                                      {row.fullname}
                                    </Typography>
                                    <Typography variant="subtitle1">{row.providerdescription}</Typography>
                                    {clientInvite && clientInvite.facetoFaceBooking === "Y" ? (
                                      <>
                                        <Typography variant="subtitle2">{row.fulladdress}</Typography>
                                        <Typography variant="subtitle2" style={{ marginTop: 20 }}>
                                          {`(Next Available Booking: ${row.nextAvailable})`}
                                        </Typography>
                                      </>
                                    ) : (
                                      <>
                                        <Typography variant="subtitle2">{`(Next Available Booking: ${row.nextAvailable})`}</Typography>
                                        <Typography variant="subtitle2">
                                          {row.appointmentType === "BOTH"
                                            ? "Appointments are via Video or Phone call"
                                            : row.appointmentType === "PHONE"
                                              ? "Appointments are via Phone call"
                                              : "Appointments are via Video call"}
                                        </Typography>
                                      </>
                                    )}
                                  </Grid>
                                </Grid>
                                {props.steps.step2.paymenttype === "Full Fee" ? (
                                  <>
                                    <Grid container style={{ marginTop: 10 }}>
                                      <Grid item sm={4}>
                                        <Typography
                                          variant="subtitle1"
                                          style={{
                                            fontWeight: 600,
                                            textAlign: "top",
                                          }}
                                        >
                                          Out of Pocket Cost
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={8} style={{ textAlign: "right" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          {row.hourlyRateOverrideGap !== "0" ? row.hourlyRateOverrideGap : row.standardFeeOutOfPocket}
                                        </Typography>
                                        <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                          You pay {row.hourlyrate} on the day
                                        </Typography>
                                        <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                          Receive back {row.hourlyRateOverrideRebate !== "0" ? row.hourlyRateOverrideRebate : row.medicareRebate} from Medicare
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </>
                                ) : null}
                                {props.steps.step2.paymenttype === "Reduced Gap" ? (
                                  <>
                                    {row.isReducedFee === "Y" ? (
                                      <>
                                        <Grid container style={{ marginTop: 10 }}>
                                          <Grid item sm={4}>
                                            <Typography
                                              variant="subtitle1"
                                              style={{
                                                fontWeight: 600,
                                                textAlign: "top",
                                              }}
                                            >
                                              Out of Pocket Cost
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={8} style={{ textAlign: "right" }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                              {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                                ? row.reducedFeeOverrideGap
                                                : row.reducedFeeOutOfPocket}
                                            </Typography>
                                            {row.reducedFee === "0" ? (
                                              <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                You pay $0 on the day
                                              </Typography>
                                            ) : (
                                              <>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  You pay {row.reducedFee} on the day
                                                </Typography>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  Receive back{" "}
                                                  {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                    ? row.reducedFeeOverrideRebate
                                                    : row.medicareRebate}{" "}
                                                  from Medicare
                                                </Typography>
                                              </>
                                            )}
                                          </Grid>
                                          {row.reducedFee !== "0" ? (
                                            <Grid item sm={12}>
                                              <Typography
                                                variant="subtitle2"
                                                style={{
                                                  fontWeight: 300,
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                Note this provider offers some flexibility, depending on client circumstances
                                              </Typography>
                                            </Grid>
                                          ) : null}
                                        </Grid>
                                      </>
                                    ) : (
                                      <>
                                        <Grid container style={{ marginTop: 10 }}>
                                          <Grid item sm={4}>
                                            <Typography
                                              variant="subtitle1"
                                              style={{
                                                fontWeight: 600,
                                                textAlign: "top",
                                              }}
                                            >
                                              Out of Pocket Cost
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={8} style={{ textAlign: "right" }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                              {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                                ? row.reducedFeeOverrideGap
                                                : row.reducedFeeOutOfPocket}
                                            </Typography>
                                            {row.reducedFee === "0" ? (
                                              <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                You pay $0 on the day
                                              </Typography>
                                            ) : (
                                              <>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  You pay {row.reducedFee} on the day
                                                </Typography>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  Receive back{" "}
                                                  {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                    ? row.reducedFeeOverrideRebate
                                                    : row.medicareRebate}{" "}
                                                  from Medicare
                                                </Typography>
                                              </>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </>
                                    )}
                                  </>
                                ) : null}
                                <Grid container style={{ marginBottom: 15, marginTop: 10 }}>
                                  {row.areasOfInterest.map((row) => {
                                    return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                                  })}
                                </Grid>
                                <Grid container style={{ height: 220 }}>
                                  <Typography variant="body2" component="p">
                                    <Interweave content={row.bio.substring(0, 700)} />
                                    {row.bio.length > 700 ? (
                                      <>
                                        ...
                                        <Badge
                                          variant="secondary"
                                          onClick={() => moreProviderBio(row.fullname, row.bio)}
                                          style={{
                                            marginRight: 5,
                                            cursor: "pointer",
                                          }}
                                        >
                                          more
                                        </Badge>
                                      </>
                                    ) : null}
                                  </Typography>
                                </Grid>
                              </CardContent>
                            </>
                          )}
                        </>
                      )}
                      <CardActions disableSpacing>
                        {props.steps.step2.paymenttype !== "" ? (
                          <>
                            {currentPsychologist.id === undefined ? (
                              props.steps.step2.paymenttype === "Bulk Billed" && row.bulkBillingAvailable === "0" && !props.steps.step2.program ? (
                                <Button variant="secondary">Not Available to Bulk Bill</Button>
                              ) : (
                                <Button
                                  variant="primary"
                                  type="submit"
                                  onClick={() => {
                                    setcurrentPsychologist(row);
                                    props.setStepValue({
                                      step2: {
                                        ...props.steps.step2,
                                        status: "Completed",
                                        data: { ...row },
                                        booking: { day: "" },
                                        providerType: providerType,
                                      },
                                      currentStep: 2,
                                    });
                                  }}
                                >
                                  Select
                                </Button>
                              )
                            ) : (
                              <Button
                                variant="secondary"
                                type="submit"
                                onClick={() => {
                                  setcurrentPsychologist({});
                                  props.setStepValue({
                                    step2: {
                                      ...props.steps.step2,
                                      status: "In Progress",
                                      data: {},
                                      booking: { day: "" },
                                      providerType: providerType,
                                    },
                                    currentStep: 2,
                                  });
                                }}
                              >
                                Change
                              </Button>
                            )}
                          </>
                        ) : (
                          <Button variant="secondary">Choose Payment Type to Select</Button>
                        )}
                        {providerType && providerType !== "Supervision" ? (
                          <IconButton
                            className={clsx(classes.expand, {
                              [classes.expandOpen]: expanded,
                            })}
                            onClick={() => handleExpandClick(row.id)}
                            aria-expanded={expanded}
                            aria-label="show more"
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        ) : null}
                      </CardActions>
                      {providerType && providerType !== "Supervision" ? (
                        <Collapse in={expanded !== row.id} timeout="auto" unmountOnExit>
                          <CardContent>
                            {row.therapyTypes &&
                              row.therapyTypes.map((row) => {
                                return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                              })}
                          </CardContent>
                        </Collapse>
                      ) : null}
                    </Card>
                  );
                })}
              </Masonry>
              {validPsychologists &&
              validPsychologists.length > 0 &&
              !showMoreProviders &&
              currentPsychologist.id === undefined &&
              !childMode &&
              providerType &&
              providerType !== "GP" &&
              providerType !== "EAP" &&
              providerType !== "Provisional" &&
              providerType !== "Supervision" &&
              providerType !== "Financial" ? (
                <Grid item md={12} style={{ textAlign: "center", marginTop: 20 }}>
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={() => {
                      setShowMoreProviders(true);
                    }}
                  >
                    Show More Providers
                  </Button>
                </Grid>
              ) : null}
              {showMoreProviders ? (
                <>
                  <Masonry
                    breakpointCols={isMobile || currentPsychologist.id !== undefined ? 1 : 3}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                  >
                    {validPsychologists.map((row, index) => {
                      return (
                        <Card className={classes.root} variant="outlined" key={index}>
                          <CardMedia
                            className={classes.media}
                            image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                            title="Psychologist"
                          />
                          <CardContent>
                            <Grid container justifyContent="space-between">
                              <Grid item sm={9}>
                                <Typography variant="h5" component="h3">
                                  {row.fullname}
                                </Typography>
                                <Typography variant="subtitle1">{row.providerdescription}</Typography>
                                {clientInvite && clientInvite.facetoFaceBooking === "Y" ? (
                                  <>
                                    <Typography variant="subtitle2">{row.fulladdress}</Typography>
                                    <Typography variant="subtitle2" style={{ marginTop: 20 }}>
                                      {`(Next Available Booking: ${row.nextAvailable})`}
                                    </Typography>
                                  </>
                                ) : (
                                  <>
                                    <Typography variant="subtitle2">{`(Next Available Booking: ${row.nextAvailable})`}</Typography>
                                    <Typography variant="subtitle2">
                                      {row.appointmentType === "BOTH"
                                        ? "Appointments are via Video or Phone call"
                                        : row.appointmentType === "PHONE"
                                          ? "Appointments are via Phone call"
                                          : "Appointments are via Video call"}
                                    </Typography>
                                  </>
                                )}
                              </Grid>
                            </Grid>
                            {props.steps.step2.paymenttype === "Full Fee" ? (
                              <>
                                <Grid container style={{ marginTop: 10 }}>
                                  <Grid item sm={4}>
                                    <Typography
                                      variant="subtitle1"
                                      style={{
                                        fontWeight: 600,
                                        textAlign: "top",
                                      }}
                                    >
                                      Out of Pocket Cost
                                    </Typography>
                                  </Grid>
                                  <Grid item sm={8} style={{ textAlign: "right" }}>
                                    <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                      {row.hourlyRateOverrideGap !== "0" ? row.hourlyRateOverrideGap : row.standardFeeOutOfPocket}
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                      You pay {row.hourlyrate} on the day
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                      Receive back {row.hourlyRateOverrideRebate !== "0" ? row.hourlyRateOverrideRebate : row.medicareRebate} from Medicare
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </>
                            ) : null}
                            {props.steps.step2.paymenttype === "Reduced Gap" ? (
                              <>
                                {row.isReducedFee === "Y" ? (
                                  <>
                                    <Grid container style={{ marginTop: 10 }}>
                                      <Grid item sm={4}>
                                        <Typography
                                          variant="subtitle1"
                                          style={{
                                            fontWeight: 600,
                                            textAlign: "top",
                                          }}
                                        >
                                          Out of Pocket Cost
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={8} style={{ textAlign: "right" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                            ? row.reducedFeeOverrideGap
                                            : row.reducedFeeOutOfPocket}
                                        </Typography>
                                        {row.reducedFee === "0" ? (
                                          <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                            You pay $0 on the day
                                          </Typography>
                                        ) : (
                                          <>
                                            <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                              You pay {row.reducedFee} on the day
                                            </Typography>
                                            <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                              Receive back{" "}
                                              {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                ? row.reducedFeeOverrideRebate
                                                : row.medicareRebate}{" "}
                                              from Medicare
                                            </Typography>
                                          </>
                                        )}
                                      </Grid>
                                      {row.reducedFee !== "0" ? (
                                        <Grid item sm={12}>
                                          <Typography
                                            variant="subtitle2"
                                            style={{
                                              fontWeight: 300,
                                              fontStyle: "italic",
                                            }}
                                          >
                                            Note this provider offers some flexibility, depending on client circumstances
                                          </Typography>
                                        </Grid>
                                      ) : null}
                                    </Grid>
                                  </>
                                ) : (
                                  <>
                                    <Grid container style={{ marginTop: 10 }}>
                                      <Grid item sm={4}>
                                        <Typography
                                          variant="subtitle1"
                                          style={{
                                            fontWeight: 600,
                                            textAlign: "top",
                                          }}
                                        >
                                          Out of Pocket Cost
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={8} style={{ textAlign: "right" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                            ? row.reducedFeeOverrideGap
                                            : row.reducedFeeOutOfPocket}
                                        </Typography>
                                        {row.reducedFee === "0" ? (
                                          <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                            You pay $0 on the day
                                          </Typography>
                                        ) : (
                                          <>
                                            <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                              You pay {row.reducedFee} on the day
                                            </Typography>
                                            <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                              Receive back{" "}
                                              {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                ? row.reducedFeeOverrideRebate
                                                : row.medicareRebate}{" "}
                                              from Medicare
                                            </Typography>
                                          </>
                                        )}
                                      </Grid>
                                    </Grid>
                                  </>
                                )}
                              </>
                            ) : null}
                            <Grid container style={{ marginBottom: 15, marginTop: 10 }}>
                              {row.areasOfInterest.map((row) => {
                                return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                              })}
                            </Grid>
                            <Grid container style={{ height: 220 }}>
                              <Typography variant="body2" component="p">
                                <Interweave content={row.bio.substring(0, 700)} />
                                {row.bio.length > 700 ? (
                                  <>
                                    ...
                                    <Badge
                                      variant="secondary"
                                      onClick={() => moreProviderBio(row.fullname, row.bio)}
                                      style={{
                                        marginRight: 5,
                                        cursor: "pointer",
                                      }}
                                    >
                                      more
                                    </Badge>
                                  </>
                                ) : null}
                              </Typography>
                            </Grid>
                          </CardContent>
                          <CardActions disableSpacing>
                            {props.steps.step2.paymenttype !== "" ? (
                              <>
                                {currentPsychologist.id === undefined ? (
                                  props.steps.step2.paymenttype === "Bulk Billed" && row.bulkBillingAvailable === "0" && !props.steps.step2.program ? (
                                    <Button variant="secondary">Not Available to Bulk Bill</Button>
                                  ) : (
                                    <Button
                                      variant="primary"
                                      type="submit"
                                      onClick={() => {
                                        setcurrentPsychologist(row);
                                        props.setStepValue({
                                          step2: {
                                            ...props.steps.step2,
                                            status: "Completed",
                                            data: { ...row },
                                            booking: { day: "" },
                                            providerType: providerType,
                                          },
                                          currentStep: 2,
                                        });
                                      }}
                                    >
                                      Select
                                    </Button>
                                  )
                                ) : (
                                  <Button
                                    variant="secondary"
                                    type="submit"
                                    onClick={() => {
                                      setcurrentPsychologist({});
                                      props.setStepValue({
                                        step2: {
                                          ...props.steps.step2,
                                          status: "In Progress",
                                          data: {},
                                          booking: { day: "" },
                                          providerType: providerType,
                                        },
                                        currentStep: 2,
                                      });
                                    }}
                                  >
                                    Change
                                  </Button>
                                )}
                              </>
                            ) : (
                              <Button variant="secondary">Choose Payment Type to Select</Button>
                            )}
                            <IconButton
                              className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                              })}
                              onClick={() => handleExpandClick(row.id)}
                              aria-expanded={expanded}
                              aria-label="show more"
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          </CardActions>
                          <Collapse in={expanded !== row.id} timeout="auto" unmountOnExit>
                            <CardContent>
                              {row.therapyTypes &&
                                row.therapyTypes.map((row) => {
                                  return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                                })}
                            </CardContent>
                          </Collapse>
                        </Card>
                      );
                    })}
                  </Masonry>
                </>
              ) : null}
            </Grid>
            {currentPsychologist.id !== undefined ? (
              <Grid item md={8}>
                {props.steps.step2.bookingdate ? (
                  <>
                    <h4>Your Booking:</h4>
                    <Grid
                      container
                      spacing={3}
                      style={{
                        maxWidth: 400,
                        marginTop: 15,
                        marginLeft: 5,
                        backgroundColor: "white",
                      }}
                    >
                      <Grid item md={3} xs={6}>
                        {providerType && providerType === "Financial" ? (
                          "Financial Counsellor:"
                        ) : (
                          <>
                            {providerType && providerType === "GP" ? (
                              "GP:"
                            ) : (
                              <>
                                {providerType && providerType === "Provisional" ? (
                                  "Provisional Psychologist"
                                ) : (
                                  <>
                                    {providerType && providerType === "Social" ? (
                                      "MH Social Worker"
                                    ) : (
                                      <>
                                        {providerType && providerType === "Nurse" ? (
                                          "Mental Health Nurse"
                                        ) : (
                                          <>
                                            {providerType && providerType === "Occupational" ? (
                                              "Occupational Therapist"
                                            ) : (
                                              <>{providerType && providerType === "Supervision" ? "Supervising Psychologist" : "Psychologist"}</>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </Grid>
                      <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                        {currentPsychologist.fullname}
                      </Grid>
                      <Grid item md={3} xs={6}>
                        Date:
                      </Grid>
                      <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                        {props.steps.step2.bookingdate && format(new Date(props.steps.step2.bookingdate), "dd-MM-yyyy")}
                      </Grid>
                      <Grid item md={3} xs={6}>
                        Time:
                      </Grid>
                      <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                        {props.steps.step2.bookingdate && format(new Date(props.steps.step2.bookingdate), "h:mm aa")}
                      </Grid>
                      {/* <Grid item md={3} xs={6}>
                      Session URL:
                    </Grid>
                    <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                      {currentPsychologist.waitingRoomURL}
                    </Grid> */}
                      <Grid item md={12}>
                        <Grid container direction="row" justifyContent="space-between">
                          <Grid item md={6} xs={6}>
                            <Button
                              variant="secondary"
                              type="submit"
                              onClick={() => {
                                props.setStepValue({
                                  step2: {
                                    ...props.steps.step2,
                                    status: "Completed",
                                    data: { ...currentPsychologist },
                                    bookingdate: null,
                                  },
                                  currentStep: 2,
                                });
                                // step2: { ...props.steps.step2, { status: 'Completed', data: {...currentPsychologist}}, bookingdate: null }
                                // setbookingConfirmed(false)
                              }}
                            >
                              Change
                            </Button>
                          </Grid>
                          <Grid item md={6} xs={6} style={{ textAlign: "right" }}>
                            <Button variant="primary" type="submit" onClick={() => submitPsychologist()}>
                              Save &amp; Next &gt;
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <>
                    <h4>Available Bookings:</h4>
                    <Row>
                      <Col md="6">
                        <Form.Group style={{ width: "100%" }}>
                          <Form.Label>TimeZone</Form.Label>
                          {!isMobile ? (
                            <OverlayTrigger defaultShow={showpopoverTimeZone} show={showpopoverTimeZone} placement="right" overlay={popoverTimeZone}>
                              <Autocomplete
                                id="profileTimeZone"
                                variant="outlined"
                                options={timeZone}
                                getOptionLabel={(option) => option.name}
                                value={
                                  timeZone.find((v) => v.systemName === currentTimeZone) || timeZone.find((v) => v.systemName === "AUS Eastern Standard Time")
                                }
                                onChange={(event, newValue) => handleTimeZoneAutocompleteChange("TimeZone", event, newValue)}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="TimeZoneSelector"
                                    style={{
                                      backgroundColor: "white",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                  />
                                )}
                              />
                            </OverlayTrigger>
                          ) : (
                            <Autocomplete
                              id="profileTimeZone"
                              variant="outlined"
                              options={timeZone}
                              getOptionLabel={(option) => option.name}
                              value={
                                timeZone.find((v) => v.systemName === currentTimeZone) || timeZone.find((v) => v.systemName === "AUS Eastern Standard Time")
                              }
                              onChange={(event, newValue) => handleTimeZoneAutocompleteChange("TimeZone", event, newValue)}
                              style={{
                                fullWidth: true,
                                display: "flex",
                                wrap: "nowrap",
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  variant="outlined"
                                  margin="dense"
                                  name="TimeZoneSelector"
                                  style={{
                                    backgroundColor: "white",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "new-password",
                                  }}
                                />
                              )}
                            />
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="register-table-responsive">
                      <Table bordered hover style={{ backgroundColor: "white" }} className="register-table">
                        <thead className="register-thead">
                          <tr className="register-tr">
                            <th>Date</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="register-tbody">
                          {matchingAvailability &&
                            matchingAvailability.map((row) => {
                              if (rowcount < 20) {
                                rowcount++;
                                return (
                                  <tr key={`key_${rowcount}`} className="register-tr">
                                    <td>{format(new Date(row.fromDate), "EEE, dd MMM, yyyy")}</td>
                                    <td>{format(new Date(row.fromDate), "HH:mm aa")}</td>
                                    <td>{format(new Date(row.toDate), "HH:mm aa")}</td>
                                    <td>
                                      <Button onClick={() => startNewBooking(row.fromDate)}>Book</Button>
                                    </td>
                                  </tr>
                                );
                              } else {
                                return null;
                              }
                            })}
                        </tbody>
                      </Table>
                    </div>
                    <Grid container style={{ marginTop: 20 }}>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="primary"
                          onClick={() => {
                            setcurrentPsychologist({});
                            props.setStepValue({
                              step2: {
                                ...props.steps.step2,
                                status: "In Progress",
                                data: {},
                                booking: { day: "" },
                                providerType: providerType,
                              },
                              currentStep: 2,
                            });
                          }}
                          style={{
                            fontWeight: "bold",
                            padding: "18px 24px", // increased vertical and horizontal padding
                            textTransform: "uppercase",
                            borderRadius: 8,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)", // subtle shadow for depth
                          }}
                        >
                          Can't find a suitable time? Try another provider
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            ) : null}
            {/* <Grid item md={12} xs={12}>
              <Grid container direction="row" justifyContent="space-between">
                <Grid item md={3} xs={6}>
                </Grid>
                <Grid item md={3} xs={6} style={{ textAlign: "right"}}>
                  {!bookingConfirmed ?               
                    <Button variant={!bookingConfirmed ? "secondary" : "primary"} type="submit">
                      Save &amp; Next &gt;
                    </Button>             
                  :
                    <Button variant="primary" type="submit" onClick={() => submitPsychologist()}>
                      Save &amp; Next &gt;
                    </Button>
                  }            
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>
        </Paper>

        <Modal show={showNewBooking} onHide={() => setShowNewBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
          <Modal.Header closeButton className="new-booking-modal">
            <Modal.Title>New Booking</Modal.Title>
          </Modal.Header>
          <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
            <Grid container spacing={2}>
              <Grid item md={3} xs={6}>
                {providerType && providerType === "Financial" ? (
                  "Financial Counsellor:"
                ) : (
                  <>
                    {providerType && providerType === "GP" ? (
                      "GP:"
                    ) : (
                      <>
                        {providerType && providerType === "Provisional" ? (
                          "Provisional Psychologist"
                        ) : (
                          <>
                            {providerType && providerType === "Social" ? (
                              "MH Social Worker"
                            ) : (
                              <>
                                {providerType && providerType === "Nurse" ? (
                                  "Mental Health Nurse"
                                ) : (
                                  <>
                                    {providerType && providerType === "Occupational" ? (
                                      "Occupational Therapist"
                                    ) : (
                                      <>{providerType && providerType === "Supervision" ? "Supervising Psychologist" : "Psychologist"}</>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {currentPsychologist.fullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Date:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {currentbookingdate && format(new Date(currentbookingdate), "dd-MM-yyyy")}
              </Grid>
              <Grid item md={3} xs={6}>
                Time:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {currentbookingdate && format(new Date(currentbookingdate), "HH:mm aa")}
              </Grid>
              {/* <Grid item md={3} xs={6}>
                Session URL:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {currentPsychologist.waitingRoomURL}
              </Grid> */}
            </Grid>
          </Modal.Body>
          <Modal.Footer className="new-booking-modal">
            <Button variant="secondary" onClick={() => setShowNewBooking(false)} className="lightButtonOutlinedLarge">
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                saveAppointment({
                  bookingdate: currentbookingdate,
                  psychologistID: currentPsychologist.id,
                  psychologistname: currentPsychologist.fullname,
                  waitingRoomURL: currentPsychologist.waitingRoomURL,
                  clientFirstName: "",
                  clientEmail: "",
                })
              }
            >
              Book Now
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showProviderBio} onHide={() => setShowProviderBio(false)} dialogClassName="invite-modal">
          <Modal.Header closeButton className="invite-modal">
            <Modal.Title>{providerBioFullName}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="invite-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
            <Grid container>
              <Typography variant="body2" component="p">
                <Interweave content={providerBioBio} />
              </Typography>
            </Grid>
          </Modal.Body>
          <Modal.Footer className="invite-modal">
            <Button variant="secondary" onClick={() => setShowProviderBio(false)} className="lightButtonOutlinedLarge">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

function ClientRegistrationForm(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 340,
      paddingRight: 20,
      marginTop: 14,
      marginLeft: 20,
    },
    linkItem: {
      minWidth: 50,
    },
    link: {
      color: "rgba(0,0,0,0.7)",
      fontSize: 12,
      fontWeight: 400,
    },
    linkSelected: {
      color: "rgba(0,0,0,1)",
      fontSize: 12,
      fontWeight: 600,
    },
  }));

  const classes = useStyles();

  const { invitetoken } = useParams();
  const { eapToken } = useParams();
  const dispatch = useDispatch();

  const validateMedicareNumber = require("validate-medicare-number");
  const [showPassword, setShowPassword] = useState(false);
  const providerType = props.providerType;
  const appointmentType = props.steps.step2.data.appointmentType;
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const registrationStatus = useSelector((state) => state.registration.regstatus);
  const [registrationAttempted, setRegistrationAttempted] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!registrationAttempted) return;

    if (registrationStatus?.form !== "client") return;

    if (registrationStatus.status === "Success") {
      setSubmitError("");
      setIsSubmitting(false);
      props.setStepValue({
        step3: { status: "Completed", data: {} },
        currentStep: 4,
      });
    } else if (registrationStatus.status === "Booking Not Available - Please choose another time") {
      setSubmitError("The selected booking time is not available. Please choose another time.");
      setIsSubmitting(false);
    } else if (registrationStatus.status === "Error") {
      setSubmitError("Something went wrong on our side while submitting your registration. Please try submitting again in a moment.");
      setIsSubmitting(false);
    }
  }, [registrationStatus, registrationAttempted]);

  // Email Duplicate Check
  const [emailIsDuplicate, setEmailIsDuplicate] = useState(false);
  const emailDuplicate = useSelector((state) => state.registration.EmailDuplicate);

  useEffect(() => {
    if (emailDuplicate === null || emailDuplicate === undefined) {
      return;
    }
    setEmailIsDuplicate(emailDuplicate === true);
    dispatch(Registration.actions.emailDuplicateClear());
  }, [emailDuplicate, dispatch]);

  // now init the fields with values so that Formik can manage the touched state
  const clientInit = {
    firstname: "",
    preferredname: "",
    surname: "",
    email: "",
    phone: "",
    clientFundingTypeID: 1,
    dob: undefined,
    gender: "",
    occupation: "",
    eapworkplace: "",
    fulladdress: "",
    latitude: "",
    longitude: "",
    postcode: "",
    timezone: props.steps.step2.userTZ,
    clientAreasOfInterest: [...props.steps.step1.data],
    hopeToGetFromTreatment: "",
    emergencycontactname1: "",
    emergencycontactphone1: "",
    emergencycontactrelation1: "",
    emergencycontactname2: "",
    emergencycontactphone2: "",
    emergencycontactrelation2: "",
    profilePassword: "",
    profilePasswordConfirmation: "",
    medicareno: "",
    medicarereferenceno: "",
    medicareexpirydate: "",
    appointmenttype: "0",
    MHCPFile: "",
    invitetoken: invitetoken,
    eapToken: eapToken,
    agreementAcceptance: false,
    clientid: null,
    paymenttype: "Reduced Gap",
    privateClient: false,
    referrerid: null,
    abn: "",
    businessName: "",
    businessAddress: "",
    backgroundinformation: "",
    gpname: "",
    gpclinicname: "",
    healthCareCard: props.steps.step2.paymenttype === "Bulk Billed" ? "Y" : "",
    unemployed: "NA",
    naturalDisaster: "NA",
    reducedGapReason: "N/A",
    bulkBilledReason: "N/A",
    consentToShareWithGP: "N/A",
    gpmentalhealthplan12months: "N/A",
    gpperinatal: "N/A",
    contract: false,
    providerType: props.providerType,
    ndisnumber: "",
    ndisdatefrom: undefined,
    ndisdateto: undefined,
    ndisplanmanagementprovider: "",
    ndisemailforinvoices: "",
    ndisdiagnosishistory: "",
    ndissupportcoordinator: "",
    ndissupportcoordinatorphone: "",
    locality: "",
    pronouns: "",
    indigenous: "N",
    program: undefined,
    programid: 0,
    appointmenttype: appointmentType === "PHONE" ? "1" : "0",
    noEmail: false,
  };

  // get the invite (if any) from state and merge with the initialised fields
  const inviteInit = useSelector((state) => state.registration.ClientInvite);
  const [clientInvite, setClientInvite] = useState({
    ...clientInit,
    ...inviteInit,
    steps: props.steps,
  });
  const [previousSteps, setPreviousSteps] = useState();
  const [checkedProgram, setCheckedProgram] = useState([]);

  // when user submits payment type form, we set it to the steps object, thus need to reload the formik form values
  useEffect(() => {
    if (previousSteps !== props.steps) {
      setClientInvite({
        ...clientInvite,
        steps: { ...props.steps },
        program: props.steps.step2.fixAOI,
        programid: props.steps.step2.programid,
        gpperinatal: props.steps.step2.programid && props.steps.step2.programid === 1 ? "Y" : "N/A",
        paymenttype:
          props.steps.step2.paymenttype === "" && providerType !== "Provisional" && providerType !== "GP"
            ? "Reduced Gap"
            : providerType === "Provisional"
              ? "Provisional"
              : providerType === "GP"
                ? "Bulk Billed"
                : providerType === "Supervision"
                  ? "Supervision"
                  : props.steps.step2.paymenttype,
        unemployed: props.steps.step2.unemployed,
        naturalDisaster: props.steps.step2.naturalDisaster,
        bulkBilledReason: props.steps.step2.bulkBilledReason,
        reducedGapReason: props.steps.step2.reducedGapReason,
        healthCareCard: props.steps.step2.paymenttype === "Bulk Billed" ? "Y" : "",
      });
      setPreviousSteps(props.steps);
    }
  }, [props.steps.step2, props.steps, providerType, previousSteps]);

  // Define Program Question responses
  const programPopulationOptions = [
    {
      id: "1",
      index: "1",
      name: "Aboriginal and/or Torres Strait Islander",
    },
    {
      id: "2",
      index: "2",
      name: "Culturally and linguistically diverse",
    },
    {
      id: "3",
      index: "3",
      name: "Migrant and Refugee",
    },
    {
      id: "4",
      index: "4",
      name: "Under 20",
    },
    {
      id: "5",
      index: "5",
      name: "Rural and Remote",
    },
  ];

  function getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1; // where the value doesn't exist
  }

  const handleToggleProgram = (value) => () => {
    const currentIndex = getIndex(value.id, checkedProgram, "id"); //checked.find(r => r.id === value.id);
    const newChecked = [...checkedProgram];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckedProgram(newChecked);
  };

  function submitForm(data) {
    postClient(data);
  }

  function postClient(data) {
    //
    const formData = new FormData();
    formData.append("privateClient", data["privateClient"]);
    formData.append("firstname", data["firstname"]);
    formData.append("preferredname", data["preferredname"]);
    formData.append("surname", data["surname"]);
    formData.append("email", data["email"]);
    formData.append("gender", data["gender"]);
    formData.append("dob", data["dob"]);
    formData.append("phone", data["phone"]);
    formData.append("fulladdress", data["fulladdress"]);
    formData.append("profilePassword", data["profilePassword"]);
    formData.append("emergencycontactname1", data["emergencycontactname1"]);
    formData.append("emergencycontactphone1", data["emergencycontactphone1"]);
    formData.append("emergencycontactrelation1", data["emergencycontactrelation1"]);
    formData.append("emergencycontactname2", data["emergencycontactname2"]);
    formData.append("emergencycontactphone2", data["emergencycontactphone2"]);
    formData.append("emergencycontactrelation2", data["emergencycontactrelation2"]);
    formData.append("medicareno", data["medicareno"]);
    formData.append("medicarereferenceno", data["medicarereferenceno"]);
    formData.append("medicareexpirydate", data["medicareexpirydate"]);
    formData.append("clientFundingTypeID", data["clientFundingTypeID"]);
    formData.append("occupation", data["occupation"]);
    formData.append("eapworkplace", data["eapworkplace"]);
    formData.append("latitude", data["latitude"]);
    formData.append("longitude", data["longitude"]);
    formData.append("postcode", data["postcode"]);
    formData.append("hopeToGetFromTreatment", data["hopeToGetFromTreatment"]);
    formData.append("appointmenttype", data["appointmenttype"]);
    formData.append("invitetoken", data["invitetoken"]);
    formData.append("eapToken", data["eapToken"]);
    formData.append("paymentType", data["paymenttype"]);
    formData.append("MHCPFile", data["MHCPFile"]);
    formData.append("psychologistid", props.steps.step2.data.id);
    formData.append("newbookingdate", props.steps.step2.bookingdate);
    formData.append("psychologistname", props.steps.step2.data.fullname);
    formData.append("waitingRoomURL", props.steps.step2.data.waitingRoomURL);
    formData.append("timezone", data["timezone"] ? data["timezone"] : props.steps.step2.userTZ);
    formData.append("providertype", props.steps.step2.providerType);
    formData.append("clientAreasOfInterest", [...props.steps.step1.data].map((aoi) => aoi.issue).join(","));
    formData.append("referrerid", clientInvite.referrerid);
    formData.append("abn", data["abn"]);
    formData.append("businessname", data["businessName"]);
    formData.append("businessaddress", data["businessAddress"]);
    formData.append("backgroundinformation", data["backgroundinformation"]);
    formData.append("gpmentalhealthplan12months", data["gpmentalhealthplan12months"]);
    formData.append("healthCareCard", data["healthCareCard"]);
    formData.append("unemployed", data["unemployed"]);
    formData.append("naturalDisaster", data["naturalDisaster"]);
    formData.append("consentToShareWithGP", data["consentToShareWithGP"]);
    formData.append("gpperinatal", data["gpperinatal"]);
    // Depending on payment type populate with correct reason
    if (data["paymenttype"] === "Reduced Gap") {
      formData.append("bulkBilledReason", data["reducedGapReason"]);
    } else {
      formData.append("bulkBilledReason", data["bulkBilledReason"]);
    }
    formData.append("gpname", data["gpname"]);
    formData.append("gpclinicname", data["gpclinicname"]);
    formData.append("ndisnumber", data["ndisnumber"]);
    formData.append("ndisdatefrom", data["ndisdatefrom"]);
    formData.append("ndisdateto", data["ndisdateto"]);
    formData.append("ndisplanmanagementprovider", data["ndisplanmanagementprovider"]);
    formData.append("ndisemailforinvoices", data["ndisemailforinvoices"]);
    formData.append("ndisdiagnosishistory", data["ndisdiagnosishistory"]);
    formData.append("ndissupportcoordinator", data["ndissupportcoordinator"]);
    formData.append("ndissupportcoordinatorphone", data["ndissupportcoordinatorphone"]);
    formData.append("pronouns", data["pronouns"]);
    formData.append("indigenous", data["indigenous"]);
    formData.append("programpopulation", checkedProgram ? checkedProgram.map((pp) => pp.name).join(",") : undefined);
    formData.append("specialisttype", clientInvite.specialisttype);
    //
    formData.append("programid", data["programid"]);
    formData.append("noemail", data["noEmail"]);
    //
    // Send to API
    //
    dispatch(Registration.actions.postClientData({ formData }));
  }

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("First Name is required"),
    preferredname: Yup.string().max(200, "Too Long"),
    surname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("Surname is required"),
    dob: Yup.string().when(["providerType"], {
      is: (providerType) => providerType !== "Supervision",
      then: Yup.string()
        .required("Date of Birth is required")
        .test("dob", "Please enter a valid date", function (value) {
          if (!value) return true; // Required validation handles empty values

          const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

          if (!match) return false;

          const year = Number(match[1]);
          const month = Number(match[2]);
          const day = Number(match[3]);

          // Ensure the date actually exists
          const dob = new Date(year, month - 1, day);

          if (dob.getFullYear() !== year || dob.getMonth() !== month - 1 || dob.getDate() !== day) {
            return false;
          }

          const age = differenceInYears(new Date(), dob);

          return age >= 1 && age <= 100;
        }),
    }),
    email: Yup.string()
      .min(2, "Too Short")
      .max(200, "Too Long")
      .email("Enter a valid email")
      .required("Email is required")
      .test("duplicate-email", "This email address is already registered", () => !emailIsDuplicate),
    phone: Yup.string().min(2, "Too Short").max(12, "Too Long").required("Phone Number is required"),
    fulladdress: Yup.string().when(["providerType"], {
      is: (providerType) => providerType !== "NDIS",
      then: Yup.string().min(4, "Too Short").max(400, "Too Long").required("Address is required"),
    }),
    pronouns: Yup.string().max(20, "Too Long"),
    profilePassword: Yup.string().min(8, "Too Short").max(50, "Too Long").required("Password is required"),
    hopeToGetFromTreatment: Yup.string().max(4000, "Too Long"),
    emergencycontactname1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact  is required"),
      }),
    emergencycontactrelation1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(20, "Too Long").required("Emergency Contact Relationship is required"),
      }),
    emergencycontactphone1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      }),
    emergencycontactname2: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long"),
      }),
    emergencycontactrelation2: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(20, "Too Long"),
      }),
    emergencycontactphone2: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long"),
      }),
    profilePasswordConfirmation: Yup.string()
      .min(8, "Too Short")
      .required("Password is required")
      .oneOf([Yup.ref("profilePassword"), null], "Passwords must match"),
    medicareno: Yup.string()
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "ALL" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Psychologist" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Social" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Nurse" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Occupational" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Clinical" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "GP" && !contract,
        then: Yup.string()
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => {
            if (value) {
              return validateMedicareNumber(value);
            } else {
              return false;
            }
          }),
      }),
    ndisnumber: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "NDIS",
      then: Yup.string().min(3, "Too Short").max(50, "Too Long").required("NDIS Number is required"),
    }),
    medicarereferenceno: Yup.string().when(["providerType", "contract"], {
      is: (providerType, contract) => ["ALL", "Psychologist", "Social", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) && !contract,
      then: (schema) => schema.matches(/^\d$/, "Must be 1 number").required("Medicare Reference Number is required"),
    }),
    medicareexpirydate: Yup.string()
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "ALL" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Psychologist" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Social" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Nurse" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Occupational" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "Clinical" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      })
      .when(["providerType", "contract"], {
        is: (providerType, contract) => providerType === "GP" && !contract,
        then: Yup.string().min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
      }),
    agreementAcceptance: Yup.boolean().oneOf([true], "You must accept the Rural Health Connect Terms and Conditions"),
    abn: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "Financial",
      then: Yup.string().max(20, "Too Long"),
    }),
    businessName: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "Financial",
      then: Yup.string().max(250, "Too Long"),
    }),
    businessAddress: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "Financial",
      then: Yup.string().max(200, "Too Long"),
    }),
    backgroundinformation: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "Financial",
      then: Yup.string().max(5000, "Too Long"),
    }),
    eapworkplace: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "EAP",
      then: Yup.string().required("Workplace is required"),
    }),
    healthCareCard: Yup.string().when(["providerType", "paymenttype"], {
      is: (providerType, paymenttype) =>
        paymenttype === "Bulk Billed" &&
        (providerType === "Clinical" ||
          providerType === "Psychologist" ||
          providerType === "Social" ||
          providerType === "Nurse" ||
          providerType === "Occupational"),
      then: Yup.string().oneOf(["Y", "N"]).required("Please advise if you have a Health Care Card"),
    }),
  });

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={clientInvite}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          setSubmitError("");
          setRegistrationAttempted(true);
          setIsSubmitting(true);

          try {
            await submitForm(values);
          } catch (error) {
            setRegistrationAttempted(false);
            setIsSubmitting(false);

            setSubmitError(error.message || "An error occurred while submitting your registration. Please try again.");
          }
        }}
      >
        {(props) => {
          const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
          const change = (name, e) => {
            e.persist();
            handleChange(e);
          };
          return (
            <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
              <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
                <Row>
                  <Col md="12">
                    <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
                      <Grid item md={6} xs={12}>
                        {providerType && providerType === "NDIS" ? (
                          <>
                            <h2>NDIS Registration</h2>
                          </>
                        ) : (
                          <h2>3. Register</h2>
                        )}
                      </Grid>
                      <Grid
                        item
                        md={3}
                        xs={12}
                        style={{
                          fontStyle: "italic",
                          fontWeight: 400,
                          textAlign: "right",
                          paddingBottom: 4,
                          fontSize: 12,
                        }}
                      >
                        * indicates required fields
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    {providerType !== "Supervision" ? (
                      <>
                        {providerType === "NDIS" ? (
                          <>
                            <Alert
                              severity="info"
                              style={{
                                marginBottom: 10,
                                marginTop: 8,
                                fontSize: 14,
                              }}
                            >
                              PLEASE NOTE - Please enter these details and we will be in contact to discuss needs and goals to find the most suitable
                              psychologist.
                            </Alert>
                          </>
                        ) : (
                          <>
                            {values.message ? (
                              <Alert
                                severity="info"
                                style={{
                                  marginBottom: 10,
                                  marginTop: 8,
                                  fontSize: 14,
                                }}
                              >
                                {values.message}
                              </Alert>
                            ) : null}
                          </>
                        )}
                      </>
                    ) : (
                      <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
                        PLEASE NOTE - Existing Providers with Rural Health Connect will need to use a different email address to access Supervison services.
                      </Alert>
                    )}
                  </Col>
                </Row>

                <hr style={{ marginTop: 4 }}></hr>
                <Row>
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>First Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstname"
                        value={values.firstname}
                        onChange={change.bind(null, "firstname")}
                        autoComplete="new-password"
                        isInvalid={touched.firstname && !!errors.firstname}
                        isValid={touched.firstname && !errors.firstname}
                      />
                      <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>Surname *</Form.Label>
                      <Form.Control
                        type="text"
                        name="surname"
                        value={values.surname}
                        onChange={change.bind(null, "surname")}
                        autoComplete="new-password"
                        isInvalid={touched.surname && !!errors.surname}
                        isValid={touched.surname && !errors.surname}
                      />
                      <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>Preferred Name (Optional)</Form.Label>
                      <Form.Control
                        type="text"
                        name="preferredname"
                        value={values.preferredname}
                        onChange={change.bind(null, "preferredname")}
                        autoComplete="new-password"
                        isInvalid={touched.preferredname && !!errors.preferredname}
                        isValid={touched.preferredname && !errors.preferredname}
                      />
                      <Form.Control.Feedback type="invalid">{errors.preferredname}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {providerType !== "Supervision" ? (
                    <Col md="2">
                      <Form.Group>
                        <Form.Label>Gender</Form.Label>
                        <Form.Control as="select" name="gender" value={values.gender} onChange={change.bind(null, "gender")}>
                          <option value="Prefer not to say">Prefer not to say</option>
                          <option value="Female">Female</option>
                          <option value="Male">Male</option>
                          <option value="Other">Other</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  ) : null}
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>Pronouns (Optional)</Form.Label>
                      <Form.Control
                        type="text"
                        name="pronouns"
                        value={values.pronouns}
                        onChange={change.bind(null, "pronouns")}
                        autoComplete="new-password"
                        isInvalid={touched.pronouns && !!errors.pronouns}
                        isValid={touched.pronouns && !errors.pronouns}
                      />
                      <Form.Control.Feedback type="invalid">{errors.pronouns}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {providerType !== "Supervision" ? (
                    <Col md="2">
                      <DateInput
                        value={values.dob}
                        onChange={(value) => setFieldValue("dob", value)}
                        onBlur={() => setFieldTouched("dob", true)}
                        isInvalid={touched.dob && !!errors.dob}
                        isValid={touched.dob && !errors.dob}
                        error={errors.dob}
                      />
                    </Col>
                  ) : null}
                </Row>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>
                        Email *{" "}
                        <span
                          style={{
                            fontStyle: "italic",
                            fontWeight: 600,
                            marginLeft: 20,
                          }}
                        >
                          <Checkbox
                            aria-label="Client No Email"
                            name="noEmail"
                            value={values.noEmail}
                            onChange={change.bind(null, "noEmail")}
                            style={{ marginRight: 5 }}
                          />
                          I don't have an email address use my mobile phone number for updates
                        </span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="email"
                        value={values.email}
                        onChange={change.bind(null, "email")}
                        onBlur={(e) => {
                          handleBlur(e);
                          if (e.currentTarget.value && e.currentTarget.value.length > 0) {
                            dispatch(Registration.actions.emailDuplicate({ emailAddress: e.currentTarget.value, checkType: "registration", clientId: "0" }));
                          }
                        }}
                        isInvalid={touched.email && !!errors.email}
                        isValid={touched.email && !errors.email}
                        autoComplete="new-password"
                      />
                      <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md="3" style={{ paddingTop: 18 }}>
                    <Form.Group>
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={values.phone}
                        onChange={change.bind(null, "phone")}
                        isInvalid={touched.phone && !!errors.phone}
                        isValid={touched.phone && !errors.phone}
                        autoComplete="new-password"
                      />
                      <Form.Control.Feedback type="invalid">{errors.phone}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {providerType !== "Supervision" && providerType !== "EAP" && providerType !== "NDIS" ? (
                    <Col md="3" style={{ paddingTop: 18 }}>
                      <Form.Group>
                        {providerType && providerType === "EAP" ? <Form.Label>Job Title (if relevant)</Form.Label> : <Form.Label>Occupation </Form.Label>}
                        <Form.Control
                          type="text"
                          name="occupation"
                          value={values.occupation}
                          onChange={change.bind(null, "occupation")}
                          autoComplete="new-password"
                        />
                      </Form.Group>
                    </Col>
                  ) : null}
                </Row>
                {providerType !== "NDIS" ? (
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Do you identify as Aboriginal and/or Torres Strait islander</Form.Label>
                        <Form.Control as="select" name="indigenous" value={values.indigenous} onChange={change.bind(null, "indigenous")}>
                          <option value="N">No</option>
                          <option value="Y">Yes</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="8">
                      <Form.Label style={{ fontWeight: 600 }}>
                        If you have a GP mental health treatment plan, that has not already been sent to RHC, please take a photo of each page including the
                        letter and send it to <a href="mailto:referrals@ruralhealthconnect.com.au">referrals@ruralhealthconnect.com.au</a>{" "}
                      </Form.Label>
                    </Col>
                  </Row>
                ) : null}
                {values.program ? (
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>
                          Do you identify as any of the following populations that we are particularly supporting via this program? (select all that apply)
                        </Form.Label>
                        <Row>
                          <Col md="6">
                            <List className={classes.root}>
                              {programPopulationOptions.map((row) => {
                                if (row.index <= programPopulationOptions.length / 2) {
                                  const labelId = `checkbox-list-label-${row.id}`;
                                  var isChecked = checkedProgram.find((r) => r.id === row.id);
                                  return (
                                    <ListItem key={row.id} role={undefined} dense button onClick={handleToggleProgram(row)}>
                                      <ListItemIcon style={{ minWidth: 40 }}>
                                        <Checkbox
                                          edge="start"
                                          checked={isChecked !== undefined}
                                          tabIndex={-1}
                                          disableRipple
                                          inputProps={{
                                            "aria-labelledby": labelId,
                                          }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        id={labelId}
                                        style={{ fontSize: 12 }}
                                        disableTypography
                                        primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>}
                                        className={classes.link}
                                      />
                                    </ListItem>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                            </List>
                          </Col>
                          <Col md="6">
                            <List className={classes.root}>
                              {programPopulationOptions.map((row) => {
                                if (row.index > programPopulationOptions.length / 2) {
                                  const labelId = `checkbox-list-label-${row.id}`;
                                  var isChecked = checkedProgram.find((r) => r.id === row.id);
                                  return (
                                    <ListItem key={row.id} role={undefined} dense button onClick={handleToggleProgram(row)}>
                                      <ListItemIcon style={{ minWidth: 40 }}>
                                        <Checkbox
                                          edge="start"
                                          checked={isChecked !== undefined}
                                          tabIndex={-1}
                                          disableRipple
                                          inputProps={{
                                            "aria-labelledby": labelId,
                                          }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        id={labelId}
                                        style={{ fontSize: 12 }}
                                        disableTypography
                                        primary={<Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>}
                                        className={classes.link}
                                      />
                                    </ListItem>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                            </List>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  {providerType !== "NDIS" ? (
                    <Col md="6">
                      <Form.Group style={{ width: "100%" }}>
                        <Form.Label>Home Address (start typing to search) *</Form.Label>
                        <PlacesAutoComplete
                          currentID={0}
                          currentfulladdress={values.fulladdress}
                          setcurrentfulladdress={(value) => setFieldValue("fulladdress", value)}
                          setcurrentLatitude={(value) => setFieldValue("latitude", value)}
                          setcurrentLongitude={(value) => setFieldValue("longitude", value)}
                          setcurrentPostCode={(value) => setFieldValue("postcode", value)}
                          isInvalid={touched.fulladdress && !!errors.fulladdress}
                          isValid={touched.fulladdress && !errors.fulladdress}
                        />
                        {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                      </Form.Group>
                    </Col>
                  ) : null}
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Password *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="profilePassword"
                          value={values.profilePassword}
                          autoComplete="new-password"
                          onChange={change.bind(null, "profilePassword")}
                          isInvalid={touched.profilePassword && !!errors.profilePassword}
                          isValid={touched.profilePassword && !errors.profilePassword}
                        />
                        <InputGroup.Append onClick={() => setShowPassword(!showPassword)}>
                          <InputGroup.Text>
                            {showPassword ? (
                              <VisibilityOffIcon fontSize="small" style={{ marginLeft: -4 }} />
                            ) : (
                              <VisibilityIcon fontSize="small" style={{ marginLeft: -4 }} />
                            )}
                          </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control.Feedback type="invalid">{errors.profilePassword}</Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Confirm Password *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          name="profilePasswordConfirmation"
                          value={values.profilePasswordConfirmation}
                          onChange={change.bind(null, "profilePasswordConfirmation")}
                          isInvalid={touched.profilePasswordConfirmation && !!errors.profilePasswordConfirmation}
                          isValid={touched.profilePasswordConfirmation && !errors.profilePasswordConfirmation}
                          autoComplete="new-password"
                        />
                        <InputGroup.Append onClick={() => setShowPassword(!showPassword)}>
                          <InputGroup.Text>
                            {showPassword ? (
                              <VisibilityOffIcon fontSize="small" style={{ marginLeft: -4 }} />
                            ) : (
                              <VisibilityIcon fontSize="small" style={{ marginLeft: -4 }} />
                            )}
                          </InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control.Feedback type="invalid">{errors.profilePasswordConfirmation}</Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>
                {providerType && (providerType === "EAP" || providerType === "NDIS") ? (
                  <>
                    <Row>
                      {providerType && providerType === "EAP" ? (
                        <>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>EAP Program Code *</Form.Label>
                              <Form.Control
                                type="text"
                                name="eapworkplace"
                                value={values.eapworkplace}
                                onChange={change.bind(null, "eapworkplace")}
                                autoComplete="new-password"
                                isInvalid={touched.eapworkplace && !!errors.eapworkplace}
                                isValid={touched.eapworkplace && !errors.eapworkplace}
                              />
                              <Form.Control.Feedback type="invalid">{errors.eapworkplace}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Job Title (if relevant)</Form.Label>
                              <Form.Control
                                type="text"
                                name="occupation"
                                value={values.occupation}
                                onChange={change.bind(null, "occupation")}
                                autoComplete="new-password"
                              />
                            </Form.Group>
                          </Col>
                        </>
                      ) : null}
                      <Col md="6">
                        <Form.Group style={{ width: "100%" }}>
                          <Form.Label>TimeZone</Form.Label>
                          <Autocomplete
                            id="profileTimeZone"
                            variant="outlined"
                            options={timeZone}
                            getOptionLabel={(option) => option.name}
                            value={timeZone.find((v) => v.systemName === values.timezone)}
                            onChange={(e, value) => {
                              setFieldValue("timezone", value.systemName);
                            }}
                            style={{
                              fullWidth: true,
                              display: "flex",
                              wrap: "nowrap",
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                type="text"
                                variant="outlined"
                                margin="dense"
                                name="TimeZoneSelector"
                                style={{
                                  backgroundColor: "white",
                                  margin: 0,
                                  padding: 0,
                                }}
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "new-password",
                                }}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                ) : null}
                <Row>
                  <Col md="12">
                    <Form.Group>
                      {providerType !== "Supervision" ? (
                        <>
                          {providerType === "NDIS" ? (
                            <>
                              <Form.Label>Additional Information</Form.Label>
                            </>
                          ) : (
                            <Form.Label>What are you hoping to get out of your sessions?</Form.Label>
                          )}
                        </>
                      ) : (
                        <Form.Label>
                          Details on the type of supervision you are after, where you are currently practicing and other relevant information.
                        </Form.Label>
                      )}
                      <Form.Control
                        as="textarea"
                        rows={4}
                        type="text"
                        name="hopeToGetFromTreatment"
                        value={values.hopeToGetFromTreatment}
                        onChange={change.bind(null, "hopeToGetFromTreatment")}
                        isInvalid={touched.hopeToGetFromTreatment && !!errors.hopeToGetFromTreatment}
                        isValid={touched.hopeToGetFromTreatment && !errors.hopeToGetFromTreatment}
                        autoComplete="new-password"
                      />
                      <Form.Control.Feedback type="invalid">{errors.hopeToGetFromTreatment}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                {providerType && (providerType === "Provisional" || providerType === "GP") ? (
                  <>
                    <Form.Label>Do you have a regular GP?</Form.Label>
                    <Row>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>GP Name *</Form.Label>
                          <Form.Control
                            type="text"
                            name="gpname"
                            value={values.gpname}
                            onChange={change.bind(null, "gpname")}
                            autoComplete="new-password"
                            isInvalid={touched.gpname && !!errors.gpname}
                            isValid={touched.gpname && !errors.gpname}
                          />
                          <Form.Control.Feedback type="invalid">{errors.gpname}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>GP Clinic Name *</Form.Label>
                          <Form.Control
                            type="text"
                            name="gpclinicname"
                            value={values.gpclinicname}
                            onChange={change.bind(null, "gpclinicname")}
                            autoComplete="new-password"
                            isInvalid={touched.gpclinicname && !!errors.gpclinicname}
                            isValid={touched.gpclinicname && !errors.gpclinicname}
                          />
                          <Form.Control.Feedback type="invalid">{errors.gpclinicname}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    {providerType && providerType === "GP" ? (
                      <>
                        <Row>
                          <Col md="9">
                            <Form.Group>
                              <Form.Label>Do we have consent to share your Mental Health Treatment Plan with them?</Form.Label>
                              <Form.Control
                                as="select"
                                name="consentToShareWithGP"
                                value={values.consentToShareWithGP}
                                onChange={change.bind(null, "consentToShareWithGP")}
                                style={{ width: 180 }}
                                isInvalid={touched.consentToShareWithGP && !!errors.consentToShareWithGP}
                                isValid={touched.consentToShareWithGP && !errors.consentToShareWithGP}
                              >
                                <option value=""></option>
                                <option value="N">No</option>
                                <option value="Y">Yes</option>
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">{errors.consentToShareWithGP}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="9">
                            <Form.Group>
                              <Form.Label> Is this booking related to Rural Health Connect's Perinatal Loss Support Program?</Form.Label>
                              <Form.Control
                                as="select"
                                name="gpperinatal"
                                value={values.gpperinatal}
                                onChange={change.bind(null, "gpperinatal")}
                                style={{ width: 180 }}
                                isInvalid={touched.gpperinatal && !!errors.gpperinatal}
                                isValid={touched.gpperinatal && !errors.gpperinatal}
                              >
                                <option value=""></option>
                                <option value="N">No</option>
                                <option value="Y">Yes</option>
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">{errors.gpperinatal}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="9">
                            <Form.Group>
                              <Form.Label>Have you received a Mental Health Plan in the last 12 Months (if so please upload it)?</Form.Label>
                              <Form.Control
                                as="select"
                                name="gpmentalhealthplan12months"
                                value={values.gpmentalhealthplan12months}
                                onChange={change.bind(null, "gpmentalhealthplan12months")}
                                style={{ width: 180 }}
                                isInvalid={touched.gpmentalhealthplan12months && !!errors.gpmentalhealthplan12months}
                                isValid={touched.gpmentalhealthplan12months && !errors.gpmentalhealthplan12months}
                              >
                                <option value=""></option>
                                <option value="N">No</option>
                                <option value="Y">Yes</option>
                              </Form.Control>
                              <Form.Control.Feedback type="invalid">{errors.gpmentalhealthplan12months}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    ) : null}
                  </>
                ) : null}
                {providerType && providerType === "NDIS" ? (
                  <>
                    <Row>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>Please enter your NDIS Number</Form.Label>
                          <Form.Control
                            type="text"
                            name="ndisnumber"
                            value={values.ndisnumber}
                            onChange={change.bind(null, "ndisnumber")}
                            autoComplete="new-password"
                            isInvalid={touched.ndisnumber && !!errors.ndisnumber}
                            isValid={touched.ndisnumber && !errors.ndisnumber}
                          />
                          <Form.Control.Feedback type="invalid">{errors.ndisnumber}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                ) : null}
                {providerType && providerType === "Financial" ? (
                  <>
                    <Row>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>Business Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="businessName"
                            value={values.businessName || ""}
                            onChange={change.bind(null, "businessName")}
                            isInvalid={touched.businessName && !!errors.businessName}
                            isValid={touched.businessName && !errors.businessName}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.businessName}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>ABN</Form.Label>
                          <Form.Control
                            type="text"
                            name="abn"
                            value={values.abn || ""}
                            onChange={change.bind(null, "abn")}
                            isInvalid={touched.abn && !!errors.abn}
                            isValid={touched.abn && !errors.abn}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.abn}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="6">
                        <Form.Group style={{ width: "100%" }}>
                          <Form.Label>Business Address (start typing to search)</Form.Label>
                          <PlacesAutoComplete
                            currentID={0}
                            currentfulladdress={values.businessAddress}
                            setcurrentfulladdress={(value) => setFieldValue("businessAddress", value)}
                            isInvalid={touched.businessAddress && !!errors.businessAddress}
                            isValid={touched.businessAddress && !errors.businessAddress}
                          />
                          {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12">
                        <Form.Group>
                          <Form.Label>Background Information</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            type="text"
                            name="backgroundinformation"
                            value={values.backgroundinformation}
                            onChange={change.bind(null, "backgroundinformation")}
                            isInvalid={touched.backgroundinformation && !!errors.backgroundinformation}
                            isValid={touched.backgroundinformation && !errors.backgroundinformation}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.backgroundinformation}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                ) : null}
                {providerType && (providerType === "Psychologist" || providerType === "Clinical" || providerType === "Occupational") ? (
                  <>
                    <Row style={{ marginBottom: 20 }}>
                      <Col md="12">
                        <Form.Group>
                          {providerType && providerType === "NDIS" ? (
                            <Form.Label>Please Upload your NDIS Plan (if you have one):</Form.Label>
                          ) : (
                            <Form.Label>
                              <strong>IMPORTANT NOTE:</strong> We need a referral a mental health treatment plan from your GP unless you want to pay full fee.
                              If we contacted you, we likely already have yours on file. However, if you are signing up directly from the website please ensure
                              you have completed one first. Upload below or your GP can fax it to us on 074573 1100. If it is multiple files then please email
                              to us - referrals@ruralhealthconnect.com.au
                            </Form.Label>
                          )}
                          <Form.Control
                            type="file"
                            name="MHCPFile"
                            onChange={(event) => setFieldValue("MHCPFile", event.currentTarget.files[0])}
                            isInvalid={touched.MHCPFile && !!errors.MHCPFile}
                            isValid={touched.MHCPFile && !errors.MHCPFile}
                            className="form-control"
                            style={{
                              paddingTop: 6,
                              paddingLeft: 6,
                              minWidth: 200,
                              maxWidth: 300,
                            }}
                          />
                          <Form.Control.Feedback type="invalid">{errors.MHCPFile}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                ) : null}
                {providerType && providerType !== "Financial" && providerType !== "Supervision" && providerType !== "NDIS" ? (
                  <>
                    <Row>
                      <Col xs={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-bold">Primary Emergency Contact</Form.Label>
                          <Form.Text className="d-block text-muted">
                            This is the person that we would call if we had concerns for your safety or the safety of others. We would not contact them
                            otherwise.
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Name*</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactname1"
                            value={values.emergencycontactname1 || ""}
                            onChange={change.bind(null, "emergencycontactname1")}
                            isInvalid={touched.emergencycontactname1 && !!errors.emergencycontactname1}
                            isValid={touched.emergencycontactname1 && !errors.emergencycontactname1}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactname1}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Relationship*</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactrelation1"
                            value={values.emergencycontactrelation1 || ""}
                            onChange={change.bind(null, "emergencycontactrelation1")}
                            isInvalid={touched.emergencycontactrelation1 && !!errors.emergencycontactrelation1}
                            isValid={touched.emergencycontactrelation1 && !errors.emergencycontactrelation1}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation1}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Phone *</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactphone1"
                            value={values.emergencycontactphone1 || ""}
                            onChange={change.bind(null, "emergencycontactphone1")}
                            isInvalid={touched.emergencycontactphone1 && !!errors.emergencycontactphone1}
                            isValid={touched.emergencycontactphone1 && !errors.emergencycontactphone1}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactphone1}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Form.Group className="mb-3">
                          <Form.Label className="fw-bold">Secondary Emergency Contact</Form.Label>
                        </Form.Group>
                      </Col>

                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactname2"
                            value={values.emergencycontactname2 || ""}
                            onChange={change.bind(null, "emergencycontactname2")}
                            isInvalid={touched.emergencycontactname2 && !!errors.emergencycontactname2}
                            isValid={touched.emergencycontactname2 && !errors.emergencycontactname2}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactname2}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Relationship</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactrelation2"
                            value={values.emergencycontactrelation2 || ""}
                            onChange={change.bind(null, "emergencycontactrelation2")}
                            isInvalid={touched.emergencycontactrelation2 && !!errors.emergencycontactrelation2}
                            isValid={touched.emergencycontactrelation2 && !errors.emergencycontactrelation2}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation2}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group>
                          <Form.Label>Phone</Form.Label>
                          <Form.Control
                            type="text"
                            name="emergencycontactphone2"
                            value={values.emergencycontactphone2 || ""}
                            onChange={change.bind(null, "emergencycontactphone2")}
                            isInvalid={touched.emergencycontactphone2 && !!errors.emergencycontactphone2}
                            isValid={touched.emergencycontactphone2 && !errors.emergencycontactphone2}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.emergencycontactphone2}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                ) : null}
                <Row>
                  {providerType &&
                  providerType !== "Financial" &&
                  providerType !== "NDIS" &&
                  providerType !== "EAP" &&
                  providerType !== "Supervision" &&
                  !clientInvite.contract &&
                  providerType !== "NthQLDPHN" ? (
                    <>
                      <Col md="3">
                        <Form.Group>
                          {providerType && providerType === "Provisional" ? (
                            <Form.Label>Medicare Card Number (Optional)</Form.Label>
                          ) : (
                            <Form.Label>Medicare Card Number</Form.Label>
                          )}
                          <Form.Control
                            type="text"
                            name="medicareno"
                            value={values.medicareno || ""}
                            onChange={change.bind(null, "medicareno")}
                            isInvalid={touched.medicareno && !!errors.medicareno}
                            isValid={touched.medicareno && !errors.medicareno}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.medicareno}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="3">
                        <Form.Group>
                          {providerType && providerType === "Provisional" ? (
                            <Form.Label>Order on Card (Optional)</Form.Label>
                          ) : (
                            <Form.Label>Order on Card</Form.Label>
                          )}
                          <Form.Control
                            type="text"
                            name="medicarereferenceno"
                            value={values.medicarereferenceno || ""}
                            onChange={change.bind(null, "medicarereferenceno")}
                            isInvalid={touched.medicarereferenceno && !!errors.medicarereferenceno}
                            isValid={touched.medicarereferenceno && !errors.medicarereferenceno}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.medicarereferenceno}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md="3">
                        <Form.Group>
                          {providerType && providerType === "Provisional" ? (
                            <Form.Label>Medicare Expiry Date (MM/YY) (Optional)</Form.Label>
                          ) : (
                            <Form.Label>Medicare Expiry Date (MM/YY)</Form.Label>
                          )}
                          <Form.Control
                            type="text"
                            name="medicareexpirydate"
                            value={values.medicareexpirydate || ""}
                            onChange={change.bind(null, "medicareexpirydate")}
                            isInvalid={touched.medicareexpirydate && !!errors.medicareexpirydate}
                            isValid={touched.medicareexpirydate && !errors.medicareexpirydate}
                            autoComplete="new-password"
                          />
                          <Form.Control.Feedback type="invalid">{errors.medicareexpirydate}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </>
                  ) : null}
                  {providerType && providerType !== "GP" && providerType !== "Supervision" ? (
                    <>
                      <Col md="3">
                        <Form.Group>
                          <Form.Label>Appointment Type</Form.Label>

                          <Form.Control
                            as="select"
                            name="appointmenttype"
                            value="0" // force Video Call
                            disabled // prevent changes
                          >
                            <option value="0">Video Call</option>
                          </Form.Control>

                          <Form.Text className="text-muted">
                            If you require a phone call rather than video please phone <strong>1800 841 045</strong>
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </>
                  ) : null}
                </Row>
                <Row>
                  <Col md="10">
                    <Form.Group>
                      <Checkbox
                        aria-label="Agreement Acceptance"
                        name="agreementAcceptance"
                        value={values.agreementAcceptance}
                        onChange={change.bind(null, "agreementAcceptance")}
                        style={{ paddingTop: 6, paddingLeft: 0 }}
                      />
                      I accept the{" "}
                      <a href="https://ruralhealthconnect.com.au/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="cell-Link">
                        Rural Health Connect Terms and Conditions of Use
                      </a>
                      <div className="error-help">{errors.agreementAcceptance}</div>
                      <Form.Control.Feedback type="invalid">{errors.agreementAcceptance}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    {submitError && (
                      <Row>
                        <Col md="12">
                          <Alert
                            severity="error"
                            style={{
                              marginTop: 15,
                              marginBottom: 20,
                              padding: 15,
                              fontSize: 13,
                              border: "1px solid #f5b7b1",
                              backgroundColor: "#fdecea",
                              borderRadius: 4,
                            }}
                          >
                            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 5 }}>We couldn't complete your registration</div>

                            <div style={{ marginBottom: 5 }}>{submitError}</div>

                            <div style={{ marginBottom: 12 }}>Everything you entered is still in the form above — nothing has been lost.</div>

                            <Button variant="primary" size="sm" onClick={() => handleSubmit()} disabled={isSubmitting} style={{ marginRight: 10 }}>
                              Try again
                            </Button>

                            <span>
                              Still stuck? Call <strong>1800 841 045</strong>
                            </span>
                          </Alert>
                        </Col>
                      </Row>
                    )}
                    <Grid container justifyContent="flex-end">
                      <Grid item>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                          {isSubmitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: 8 }} />
                              Submitting...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </Paper>
            </form>
          );
        }}
      </Formik>
    </>
  );
}

function ClientSupportFormConfirmation(props) {
  return (
    <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
      <h3>Contact Form Submitted successfully.</h3>
      <p style={{ marginTop: 30 }}>We will be in contact shortly.</p>
    </Paper>
  );
}

function ClientNoWWCCProviders(props) {
  return (
    <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
      <Alert
        style={{
          backgroundColor: "#DAF3F4",
          borderColor: "#CEE6E7",
          marginBottom: 15,
          fontSize: 16,
        }}
        severity="info"
      >
        <p>
          Unfortunately there are no appointments with a qualified provider available at this time. In this case please call Rural Health Connect on 0493 432
          144 or 0493201005{" "}
        </p>
      </Alert>
    </Paper>
  );
}

function ClientRegistrationConfirmation(props) {
  return (
    <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
      <h3>Registration successful.</h3>
      <p style={{ marginTop: 30 }}>Congratulations, your Rural Health Connect account has been created.</p>
      <p>You may now login to the portal to make and manage your bookings and your profile.</p>
      <p style={{ marginTop: 20 }}>
        <Link to="/auth/login" className="kt-login__logo">
          <Button>Portal Login</Button>
        </Link>
      </p>
    </Paper>
  );
}

function ClientRegistrationNotReady(props) {
  return (
    <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
      <Row>
        <Col md="12">
          <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
            <Grid item md={6} xs={12}>
              <h2>3. Register</h2>
            </Grid>
            <Grid
              item
              md={3}
              xs={6}
              style={{
                fontStyle: "italic",
                fontWeight: 400,
                textAlign: "right",
                paddingBottom: 4,
                fontSize: 12,
              }}
            >
              * indicates required fields
            </Grid>
          </Grid>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          {!(props.steps.step1.data.length > 0) && props.providerType !== "GP" && props.providerType !== "Supervision" ? (
            <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
              <span>
                You must select at least one area of interest.<br></br>
              </span>
            </Alert>
          ) : (
            ""
          )}
          {!(props.steps.step2.data.id && props.steps.step2.data.id > 0) ? (
            <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
              <span>
                You must select a Provider before completing the registration form.<br></br>
              </span>
            </Alert>
          ) : (
            ""
          )}
          {!(props.steps.step2.userTZ && props.steps.step2.userTZ.length > 0) ? (
            <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
              <span>
                You must select a Timezone before completing the registration form.<br></br>
              </span>
            </Alert>
          ) : (
            ""
          )}
          {!(props.steps.step2.bookingdate && props.steps.step2.bookingdate.length > 0) ? (
            <Alert severity="info" style={{ marginBottom: 10, marginTop: 8, fontSize: 14 }}>
              <span>
                You must book your first appointment before completing the registration form.<br></br>
              </span>
            </Alert>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <hr style={{ marginTop: 4 }}></hr>
      <Button onClick={() => props.setStepValue({ currentStep: 2 })}>&lt; Back</Button>
    </Paper>
  );
}

function PageWrapper(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: "rgba(0,0,0,0)",
    },
    linkItem: {
      minWidth: 50,
    },
    linkIcon: {
      color: "rgba(255,255,255,0.7)",
      fontSize: 24,
      fontWeight: 300,
    },
    linkIconSelected: {
      color: "white",
      fontSize: 24,
    },
    link: {
      color: "rgba(255,255,255,0.7)",
      fontSize: 16,
      fontWeight: 300,
    },
    linkSelected: {
      color: "white",
      fontSize: 16,
      fontWeight: 600,
    },
  }));

  const classes = useStyles();

  // change width of sidebar for screensize
  const isMobile = useMediaQuery("(max-width: 1024px)");
  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div id="kt_login" className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
            <div
              className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
              style={{
                padding: 20,
                maxWidth: isMobile ? 1024 : 320,
                backgroundImage: `url(${toAbsoluteUrl("/media/bg/rhc-farm.jpg")})`,
                backgroundSize: "auto",
              }}
            >
              <div className="kt-grid__item">
                <Link to="/auth/login" className="kt-login__logo">
                  <img alt="Logo" src={toAbsoluteUrl("/media/logos/logo-3.png")} style={{ marginLeft: -10 }} />
                </Link>
              </div>
              <div className="kt-grid__item kt-grid__item--fluid kt-grid ">
                <div className="kt-grid__item kt-grid__item--middle">
                  <h3 className="kt-login__title" style={{ marginTop: isMobile ? 0 : 80 }}>
                    Rural Health Connect
                  </h3>
                  {props.providerType !== "NDIS" ? (
                    <>
                      <h4 className="kt-login__subtitle" style={{ marginTop: 20 }}>
                        Welcome to the Client Registration process. There are three steps to complete:
                      </h4>
                      <div className={classes.root}>
                        <List component="nav" aria-label="main mailbox folders">
                          <ListItem button onClick={() => props.setStepValue({ currentStep: 1 })}>
                            <ListItemIcon className={classes.linkItem}>
                              <HelpOutlineIcon className={props.steps.currentStep === 1 ? classes.linkIconSelected : classes.linkIcon} />
                            </ListItemIcon>
                            <ListItemText
                              disableTypography
                              primary={
                                <Typography className={props.steps.currentStep === 1 ? classes.linkSelected : classes.link}>
                                  {props.providerType && props.providerType === "Financial" ? <>1. Location</> : <>1. Areas of Interest</>}
                                </Typography>
                              }
                              className={classes.link}
                            />
                          </ListItem>
                          <ListItem button onClick={() => props.setStepValue({ currentStep: 2 })}>
                            <ListItemIcon className={classes.linkItem}>
                              <GroupIcon className={props.steps.currentStep === 2 ? classes.linkIconSelected : classes.linkIcon} />
                            </ListItemIcon>
                            <ListItemText
                              disableTypography
                              primary={
                                <Typography className={props.steps.currentStep === 2 ? classes.linkSelected : classes.link}>
                                  {props.providerType && props.providerType === "Financial" ? (
                                    <>2. Financial Counsellor</>
                                  ) : (
                                    <>
                                      {props.providerType && props.providerType === "GP" ? (
                                        <>2. GP</>
                                      ) : (
                                        <>
                                          {props.providerType && props.providerType === "Provisional" ? (
                                            <>2. Provisional Psychologist</>
                                          ) : (
                                            <>
                                              {props.providerType && props.providerType === "Social" ? (
                                                <>2. MH Social Worker</>
                                              ) : (
                                                <>
                                                  {props.providerType && props.providerType === "Nurse" ? (
                                                    <>2. Mental Health Nurse</>
                                                  ) : (
                                                    <>
                                                      {props.providerType && props.providerType === "Occupational" ? (
                                                        <>2. Occupational Therapist</>
                                                      ) : (
                                                        <>
                                                          {props.providerType && props.providerType === "Supervision" ? (
                                                            <>2. Supervising Psychologist</>
                                                          ) : (
                                                            <>{props.contract ? <>2. Practitioner</> : <>2. Practitioner</>}</>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </Typography>
                              }
                              className={classes.link}
                            />
                          </ListItem>
                          <ListItem button onClick={() => props.setStepValue({ currentStep: 3 })}>
                            <ListItemIcon className={classes.linkItem}>
                              <AssignmentIcon className={props.steps.currentStep === 3 ? classes.linkIconSelected : classes.linkIcon} />
                            </ListItemIcon>
                            <ListItemText
                              disableTypography
                              primary={<Typography className={props.steps.currentStep === 3 ? classes.linkSelected : classes.link}>3. Register</Typography>}
                              className={classes.link}
                            />
                          </ListItem>
                        </List>
                        {/* <div style={{ color: 'white', maxWidth: 300 }}>{JSON.stringify(props.steps.step2)}</div> */}
                      </div>
                    </>
                  ) : (
                    <h4 className="kt-login__subtitle" style={{ marginTop: 20 }}>
                      Welcome to the Client Registration process. Please register
                    </h4>
                  )}
                </div>
              </div>
              <div className="kt-grid__item">
                <div className="kt-login__info">
                  <div className="kt-login__copyright">&copy; 2026 Rural Health Connect</div>
                </div>
              </div>
            </div>

            <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper login-bg">{props.children}</div>
          </div>
        </div>
      </div>
    </>
  );
}
